export const bibliography = {
  english: {
    bibliographyLabel: 'Bibliography',


    bibliography1:'Arthur A. Macdonell, Sanskrit-English Dictionary, Longmans Green And Co., New York, 1893.',
    bibliography2:'Atar Singh (Dr.), Punjabi-English Dictionary, Punjabi University, Patiala, Second Edition, 2015.',
    bibliography3:'Baldev Raj Gupta, Research in Indian Linguistics, Ariana Publishing House, New Delhi, 1983.',
    bibliography4:'C. Shackle, A Guru Nanak Glossary, Heritage publishers, New Delhi, Third Edition, 2011.',
    bibliography5:'Christopher Shackle, An introduction to the sacred language of the Sikhs, Heritage Publishers, New Delhi.',
    bibliography6:'David Lodge (Editor), 20th Century Literary Criticism, Longman, London, 1972.',
    bibliography7:'David Lodge (Editor), Modern Criticism And Theory, Longman, London, 1988.',
    bibliography8:'Dictionary of The Panjabi Language, lodiana Mission, Ludhiana, 1959.',
    bibliography9:'Darshan Singh (Dr.), Guru Granth Sahib: Line to Line English Translation & Transliteration, Sikh University Press, Belgium, Third Edition, 2010.',
    bibliography10:'Edward O’brien, Glossary of the Multani Language compared with Punjabi and Sindhi, Printed at The Punjab Government Civil Secretariat Press, Lahore, 1881.',
    bibliography11:'F. Steingass, A Comprehensive Persian-English Dictionary, Manohar Publishers, New Delhi, 2008.',
    bibliography12:'G.S. Randhawa, Guru Nanak\'s Asa di Var, Guru Nanak Dev University, Amritsar, 1997.',
    bibliography13:'G.V. Tagare ( Dr.), A Historical Grammar of Apabhransa, Motilal Banarsidass, Delhi, 1987.',
    bibliography14:'George Yule, The Study of Language, Cambridge University, Cambridge, 1985.',
    bibliography15:'Gopal Singh (Dr.), Sri Guru Granth Sahib English Translation Vol. 4, Allied Publisher Pvt. Limited New Delhi, Twelfth Edition, 2005.',
    bibliography16:'Grierson (Dr.), Dr, Grierson on Punjabi, Pb. Language Department, Patiala, 1961.',
    bibliography17:'Gurbachan Singh Makin, The Essence of Sri Guru Granth Vol. 5, Lahore Book Shop, Ludhiana, Second Edition, 2003.',
    bibliography18:'Gurbachan Singh Talib, Sri Guru Granth Sahib English Translation Vol. 4, Punjabi University, Patiala, 2004.',
    bibliography19:'Gurnam Singh, Sikh Musicology, Gurmat Prakashan, Patiala, 2013.',
    bibliography20:'H. H. Wilson, Dictionary in Sanskrit And English, The General Committee of Public Instruction In Bengal, Calcutta, 1832.',
    bibliography21:'Harbans Singh (Editor), Encyclopaedia of Sikhism (4 Vols.), Punjabi University, Patiala, 2004.',
    bibliography22:'Hardev Bhari (Dr.), Lahndi Phonology, Bharti Press Prakashan, Allahabad, 1962.',
    bibliography23:'Harinder Singh, Jaswant Singh, and Surenderpal Singh, Guru Granth Sahib (Its Language and Grammar), The Sikh Research Institute, USA, 2014.',
    bibliography24:'Harjinder Singh Dilgeer (Dr.), Guru Granth Sahib (Text in Punjabi, Transliteration in Roman Script and Translation in English - with explanation), The Sikh University, England, 2016.',
    bibliography25:'Jaswant Singh (Dr.), The Abode of God, Central Sikh Gurdwara Board, Singapore, 2009.',
    bibliography26:'Jaswant Singh (Dr.), The Divine Path, Central Sikh Gurdwara Board, Singapore, 2011.',
    bibliography27:'John Shakespeare, A Dictionary Hindustani and English, J.L. Cox and Son, London, 1987.',
    bibliography28:'John T. Platts, A Dictionary of Urdu, Classical Hindi and English, Manohar Publishers, New Delhi, 2006.',
    bibliography29:'Kahan Singh Nabha (Bhai), Encyclopaedia of Sikh Literature, Punjabi University, Patiala, 2014.',
    bibliography31:'Kanwaljit Singh (Dr.), Sikh Sacred Music, Punjabi School Denmark, Copenhagen, Denmark, Undated.',
    bibliography32:'M. Monier-Williams (Sir), A Sanskrit-English Dictionary, Bharatiya Granth Niketan, New Delhi, 2010.',
    bibliography33:'Manmohan Singh, Sri Guru Granth Sahib English/Punjabi Translation Vol. 8, Shiromani Gurdwara Parbandhak Committee, Amritsar, Eighth Edition, 2009.',
    bibliography34:'Maya singh (Bhai), The Punjabi Dictionary, Nirmal Publishers, New Delhi, 1998.',
    bibliography35:'Naresh Parsad Rastogi (Dr.), Origin of Brahmi Script, Chowkhamba Saraswati Bhawan, Varanasi, 1980.',
    bibliography36:'Puran Singh, Spirit of the Sikh, Part 2, Vol. 1, Punjabi University, Patiala, Second Edition, 1993.',
    bibliography37:'R.L.Turner, A Comparative Dictionary of the Indo-Aryan Languages, Motilal Banarsidass, New Delhi, Second Edition, 1999.',
    bibliography38:'Revd. Canon. W.P. Hares, An English-Punjabi Dictionary, Church Missionary Society, Lodhiana, 1929.',
    bibliography39:'Sahib Singh (Prof.), About Compilation of Sri Guru Granth Sahib, Singh Brothers, Amritsar, 1996.',
    bibliography40:'Satish Rohra (Dr.), Standard Trilingual Dictionary (Sindhi-Hindhi-English), Indian Institute of Sindhology, Adipur, 2011.',
    bibliography41:'Surindar Singh Kohli, Dictionary of Guru Granth Sahib, Singh Brothers, Amritsar, 1996.',
    bibliography42:'Surindar Singh Kohli, Dictionary of Mythological References in Guru Granth Sahib, Singh Brothers, Amritsar, Second Edition, 1999.',
    bibliography43:'Surindar Singh Kohli, Guru Granth Sahib: An Analytical Study, Singh Brothers, Amritsar, Reprint, 2005.',
    bibliography44:'Team AWAT (A Word A Thought), Gurbani Gems, Vols. 1 & 2, Singh Brothers, Amritsar, Reprint, 2017.',
    bibliography45:'Team AWAT (A Word A Thought), The Beauty of Jap Ji Sahib, Singh Brothers, Amritsar, 2018.',
    bibliography46:'T. W. Rhys Davids, Pali-English Dictionary, The Pali Text Society’s, Chipstead, 1921-25.',
    bibliography47:'Theos Bernard, Hindu Philosophy, Jaico Publishing house, Bombay, 1957.',


    /*bibliography1:
      'Arthur A. Macdonell, Sanskrit-English Dictionary, Longmans Green And Co., New York, 1893.',
    bibliography2:
      'Atar Singh (Dr.), Punjabi-English Dictionary, Punjabi University, Patiala, Second Edition, 2015.',
    bibliography3:
      'Baldev Raj Gupta, Research in Indian Linguistics, Ariana Publishing House, New Delhi, 1983.',
    bibliography4:
      'C. Shackle, A Guru Nanak Glossary, Heritage publishers, New Delhi, Third Edition, 2011.',
    bibliography5:
      'Christopher Shackle, An introduction to the sacred language of the Sikhs, Heritage Publishers, New Delhi.',
    bibliography6:
      'David Lodge (Editor), 20th Century Literary Criticism, Longman, London, 1972.',
    bibliography7:
      'David Lodge (Editor), Modern Criticism And Theory, Longman, London, 1988.',
    bibliography8:
      'Dictionary of The Panjabi Language, lodiana Mission, Ludhiana, 1959.',
    bibliography9:
      'Darshan Singh (Dr.), Guru Granth Sahib: Line to Line English Translation & Transliteration, Sikh University Press, Belgium, Third Edition, 2010.',
    bibliography10:
      'Edward O’brien, Glossary of the Multani Language compared with Punjabi and Sindhi, Printed at The Punjab Government Civil Secretariat Press, Lahore, 1881.',
    bibliography11:
      'F. Steingass, A Comprehensive Persian-English Dictionary, Manohar Publishers, New Delhi, 2008.',
    bibliography12:
      'G.S. Randhawa, Guru Nanak\'s Asa di Var, Guru Nanak Dev University, Amritsar, 1997.',
    bibliography13:
      'G.V. Tagare ( Dr.), A Historical Grammar of Apabhransa, Motilal Banarsidass, Delhi, 1987.',
    bibliography14:
      'George Yule, The Study of Language, Cambridge University, Cambridge, 1985.',
    bibliography15:
      'Gopal Singh (Dr.), Sri Guru Granth Sahib English Translation Vol. 4, Allied Publisher Pvt. Limited New Delhi, Twelfth Edition, 2005.',
    bibliography16:
      'Grierson (Dr.), Dr, Grierson on Punjabi, Pb. Language Department, Patiala, 1961.',
    bibliography17:
      'Gurbachan Singh Makin, The Essence of Sri Guru Granth Vol. 5, Lahore Book Shop, Ludhiana, Second Edition, 2003.',
    bibliography18:
      'Gurbachan Singh Talib, Sri Guru Granth Sahib English Translation Vol. 4, Punjabi University, Patiala, 2004.',
    bibliography19:
      'Gurnam Singh, Sikh Musicology, Gurmat Prakashan, Patiala, 2013.',
    bibliography20:
      'H. H. Wilson, Dictionary in Sanskrit And English, The General Committee of Public Instruction In Bengal, Calcutta, 1832.',
    bibliography21:
      'Harbans Singh (Editor), Encyclopaedia of Sikhism (4 Vols.), Punjabi University, Patiala, 2004.',
    bibliography22:
      'Hardev Bhari (Dr.), Lahndi Phonology, Bharti Press Prakashan, Allahabad, 1962.',
    bibliography23:
      'Harinder Singh, Jaswant Singh, and Surenderpal Singh, Guru Granth Sahib (Its Language and Grammar), The Sikh Research Institute, USA, 2014.',
    bibliography24:
      'Harjinder Singh Dilgeer (Dr.), Guru Granth Sahib (Text in Punjabi, Transliteration in Roman Script and Translation in English - with explanation), The Sikh University, England, 2016.',
    bibliography25:
      'Jaswant Singh (Dr.), The Abode of God, Central Sikh Gurdwara Board, Singapore, 2009.',
    bibliography26:
      'Jaswant Singh (Dr.), The Divine Path, Central Sikh Gurdwara Board, Singapore, 2011.',
    bibliography27:
      'John Shakespeare, A Dictionary Hindustani and English, J.L. Cox and Son, London, 1987.',
    bibliography28:
      'John T. Platts, A Dictionary of Urdu, Classical Hindi and English, Manohar Publishers, New Delhi, 2006.',
    bibliography29:
      'Kahan Singh Nabha (Bhai), Encyclopaedia of Sikh Literature, Punjabi University, Patiala, 2014.',
    bibliography30:
      'Kanwaljit Singh (Dr.), Sikh Sacred Music, Punjabi School Denmark, Copenhagen, Denmark, Undated.',
    bibliography31:
      'M. Monier-Williams (Sir), A Sanskrit-English Dictionary, Bharatiya Granth Niketan, New Delhi, 2010.',
    bibliography32:
      'Manmohan Singh, Sri Guru Granth Sahib English/Punjabi Translation Vol. 8, Shiromani Gurdwara Parbandhak Committee, Amritsar, Eighth Edition, 2009.',
    bibliography33:
      'Maya singh (Bhai), The Punjabi Dictionary, Nirmal Publishers, New Delhi, 1998.',
    bibliography34:
      'Naresh Parsad Rastogi (Dr.), Origin of Brahmi Script, Chowkhamba Saraswati Bhawan, Varanasi, 1980.',
    bibliography35:
      'Puran Singh, Spirit of the Sikh, Part 2, Vol. 1, Punjabi University, Patiala, Second Edition, 1993.',
    bibliography36:
      'R.L.Turner, A Comparative Dictionary of the Indo-Aryan Languages, Motilal Banarsidass, New Delhi, Second Edition, 1999.',
    bibliography37:
      'Revd. Canon. W.P. Hares, An English-Punjabi Dictionary, Church Missionary Society, Lodhiana, 1929.',
    bibliography38:
      'Sahib Singh (Prof.), About Compilation of Sri Guru Granth Sahib, Singh Brothers, Amritsar, 1996.',
    bibliography39:
      'Satish Rohra (Dr.), Standard Trilingual Dictionary (Sindhi-Hindhi-English), Indian Institute of Sindhology, Adipur, 2011.',
    bibliography40:
      'Surindar Singh Kohli, Dictionary of Guru Granth Sahib, Singh Brothers, Amritsar, 1996.',
    bibliography41:
      'Surindar Singh Kohli, Dictionary of Mythological References in Guru Granth Sahib, Singh Brothers, Amritsar, Second Edition, 1999.',
    bibliography42:
      'Surindar Singh Kohli, Guru Granth Sahib: An Analytical Study, Singh Brothers, Amritsar, Reprint, 2005.',
    bibliography43:
      'Team AWAT (A Word A Thought), Gurbani Gems, Vols. 1 & 2, Singh Brothers, Amritsar, Reprint, 2017.',
    bibliography44:
      'Team AWAT (A Word A Thought), The Beauty of Jap Ji Sahib, Singh Brothers, Amritsar, 2018.',
    bibliography45:
      'T. W. Rhys Davids, Pali-English Dictionary, The Pali Text Society’s, Chipstead, 1921-25.',
    bibliography46:
      'Theos Bernard, Hindu Philosophy, Jaico Publishing house, Bombay, 1957.',*/
    
  },
  panjabi: {
    
    bibliographyLabel: 'ਪੁਸਤਕ ਸੂਚੀ',

    bibliography1:'ਓਅੰਕਾਰ ਸਿੰਘ (ਸ.), ਪੋਠੋਹਾਰੀ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੦੧',
    bibliography2:'ਓਮਕਾਰ ਨਾਥ ਕੌਲ (ਡਾ.), ਪੰਜਾਬੀ ਕਸ਼ਮੀਰੀ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੯੯',
    bibliography3:'ਅਕਾਲੀ ਕੌਰ ਸਿੰਘ, ਗੁਰੁ ਸ਼ਬਦ ਰਤਨ ਪ੍ਰਕਾਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੧੯੮੬',
    bibliography4:'ਅਗਿਆਤ, ਗੁਰਮਤਿ ਸੰਗੀਤ, ਧਰਮ ਪ੍ਰਚਾਰ ਕਮੇਟੀ, ਸੈਂਟਰਲ ਖ਼ਾਲਸਾ ਯਤੀਮਖ਼ਾਨਾ (ਚੀਫ਼ ਖ਼ਾਲਸਾ ਦੀਵਾਨ), ਜੀ. ਟੀ. ਰੋਡ, ਅੰਮ੍ਰਿਤਸਰ, ਦੂਜੀ ਛਾਪ, ੨੦੦੮',
    bibliography5:'ਅਮਰ ਸਿੰਘ ਚਾਕਰ (ਸ.) (ਸੰਪਾ.), ਵਾਰਾਂ ਭਾਈ ਗੁਰਦਾਸ, ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ਸਤਵੀਂ ਛਾਪ, ੧੯੯੮',
    bibliography6:'ਅਮਰਵੰਤ ਸਿਘ (ਡਾ.), ਅਰਬੀ-ਫ਼ਾਰਸੀ ਵਿਚੋਂ ਉਤਪੰਨ ਪੰਜਾਬੀ ਸ਼ਬਦਾਵਲੀ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੩',
    bibliography7:'ਅੰਮ੍ਰਿਤਪਾਲ ਕੌਰ (ਪ੍ਰੋ.) (ਸੰਪਾ.), ਖੋਜ ਪਤ੍ਰਿਕਾ (ਬਾਣੀ ਕਾਵਿ ਰੂਪ ਵਿਸ਼ੇਸ਼ ਅੰਕ), ਅੰਕ ੫੮, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੩',
    bibliography8:'ਅਲੰਕਾਰ ਸਿੰਘ (ਅਨੁ. ਅਤੇ ਸੰਪਾ.), ਹਿੰਦੁਸਤਾਨੀ ਸੰਗੀਤ: ਵਿਭਿੰਨ ਪਰਿਪੇਖ, ਗਰੇਸ਼ੀਅਸ ਬੁਕਸ, ਪਟਿਆਲਾ, ੨੦੦੯',
    bibliography9:'ਅਵਤਾਰ ਸਿੰਘ (ਭਾਈ) ਤੇ ਗੁਰਚਰਨ ਸਿੰਘ (ਭਾਈ), ਗੁਰਬਾਣੀ ਸੰਗੀਤ ਪ੍ਰਾਚੀਨ ਰੀਤ ਰਤਨਾਵਲੀ (ਦੋ ਭਾਗ) ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਚੌਥੀ ਛਾਪ, ੨੦੧੬',
    bibliography10:'ਐਸ. ਐਸ. ਕਿਸ਼ਨਪੁਰੀ (ਡਾ.), ਪੁਆਧੀ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੦੮',
    bibliography11:'ਇੰਦਰਮੋਹਨ ਸਿੰਘ (ਪ੍ਰੋ.), ਪੰਜਾਬੀ ਸੰਸਕ੍ਰਿਤ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੭',
    bibliography12:'ਸੰਤਾ ਸਿੰਘ ਤਤਲੇ, ਗੁਰਬਾਣੀ ਤੱਤ ਸਾਰ (ਛੇ ਭਾਗ), ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੧੫',
    bibliography13:'ਸਤਿਬੀਰ ਸਿੰਘ (ਪ੍ਰਿੰ.), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਦਾ ਸਾਰ-ਵਿਸਥਾਰ, ਨਿਊ ਬੁੱਕ ਕੰਪਨੀ, ਜਲੰਧਰ, ੧੯੮੭',
    bibliography14:'ਸੱਯਦ ਅਬੁਲ ਆਲਾ ਮੌਦੂਦੀ, ਕੁਰਆਨ ਮਜੀਦ: ਅਨੁਵਾਦ ਤੇ ਸੰਖੇਪ ਟੀਕਾ ਸਹਿਤ, ਰਮਜ਼ਾਨ ਸਈਦ, (ਪੰਜਾਬੀ ਅਨੁ.), ਪੰਜਾਬੀ ਇਸਲਾਮਿਕ ਪਬਲੀਕੇਸ਼ਨਜ਼, ਮਲੇਰਕੋਟਲਾ, ੨੦੧੩',
    bibliography15:'ਸਰਦੂਲ ਸਿੰਘ ਕਵੀਸ਼ਰ, ਸਿੱਖ ਧਰਮ ਦਰਸ਼ਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੧੯੯੩',
    bibliography16:'ਸਰਬਜਿੰਦਰ ਸਿੰਘ (ਡਾ.) (ਸੰਪਾ.), ਨਾਨਕ ਪ੍ਰਕਾਸ਼ ਪਤ੍ਰਿਕਾ, ਅੰਕ ਦੂਜਾ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੧',
    bibliography17:'ਸਾਹਿਬ ਸਿੰਘ (ਪ੍ਰੋ.), ਆਦਿ ਬੀੜ ਬਾਰੇ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੯੯',
    bibliography18:'ਸਾਹਿਬ ਸਿੰਘ (ਪ੍ਰੋ.), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਦਰਪਣ (ਦਸ ਪੋਥੀਆਂ), ਰਾਜ ਪਬਲਿਸ਼ਰਜ਼, ਜਲੰਧਰ, ੧੯੬੨',
    bibliography19:'ਸਾਹਿਬ ਸਿੰਘ (ਪ੍ਰੋ.), ਗੁਰਬਾਣੀ ਵਿਆਕਰਣ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਉਨ੍ਹੀਵੀਂ ਛਾਪ, ੨੦੧੫',
    bibliography20:'ਸ਼ਾਮ ਸਿੰਘ, ਪ੍ਰਯਾਇ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਭਾਈ ਨਰੈਣ ਸਿੰਘ ਐਂਗਲੋ ਉਰਦੂ ਐਂਡ ਗੁਰਮੁਖੀ ਪ੍ਰੈਸ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੦੬',
    bibliography21:'ਸੀਹਾਂ ਉਪਲ, ਸਾਖੀ ਮਹਲੁ ਪਹਿਲੇ ਕੀ, ਸ.ਸ.ਪਦਮ (ਸੰਪਾ.), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੪',
    bibliography22:'ਸੁਆਮੀ ਅਨੰਦਘਨ, ਆਸਾ ਦੀ ਵਾਰ ਦਾ ਟੀਕਾ (ਸੰਪਾਦਕ ਡਾ. ਰਤਨ ਸਿੰਘ ਜੱਗੀ), ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੯',
    bibliography23:'ਸੁਖਦਿਆਲ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬ ਦਾ ਇਤਿਹਾਸ: ਗੁਰੂ ਕਾਲ ੧੪੬੯-੧੫੩੯ (ਭਾਗ ਪੰਜਵਾਂ), ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography24:'ਸੁਖਵੰਤ ਸਿੰਘ (ਭਾਈ ), ਗੁਰੂ ਨਾਨਕ ਸੰਗੀਤ ਪੱਧਤੀ ਗ੍ਰੰਥ, ਗੁਰਦੁਆਰਾ ਗੁਰ ਗਿਆਨ ਪ੍ਰਕਾਸ਼, ਜਵੱਦੀ ਟਕਸਾਲ, ਲੁਧਿਆਣਾ, ਮਿਤੀ ਹੀਣ',
    bibliography25:'ਸੁਖਵਿੰਦਰ ਸਿੰਘ ਸੰਘਾ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਅਕਾਦਮੀ, ਜਲੰਧਰ, ਦਸਵੀਂ ਛਾਪ, ੨੦੧੭',
    bibliography26:'ਸੁਤਿੰਦਰ ਸਿੰਘ ਨੂਰ, ੴ ਵਿਕਾਸ ਅਤੇ ਸੰਕਲਪੀ ਚਿਹਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਟੀ, ਪਟਿਆਲਾ, ੨੦੧੨',
    bibliography27:'ਸੁਤੇ ਪ੍ਰਕਾਸ਼, ਪ੍ਰਯਾਇ ਆਦਿ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਭਾਈ ਹਰੀ ਸਿੰਘ ਲਿਖਾਰੀ ਬੁੰਗਾ ਸਿੰਘ ਪੁਰੀਆਂ, ਅੰਮ੍ਰਿਤਸਰ, ੧੮੯੬',
    bibliography28:'ਸੁਰਿੰਦਰ ਸਿੰਘ ਕੋਹਲੀ (ਸੰਪਾ.), ਪੰਜਾਬੀ ਸਾਹਿਤ ਕੋਸ਼ (ਭਾਗ ਤੀਜਾ), ਪਬਲੀਕੇਸ਼ਨ ਬਿਊਰੋ, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ੧੯੯੨',
    bibliography29:'ਸੁਰਿੰਦਰ ਸਿੰਘ ਕੋਹਲੀ (ਸੰਪਾ.), ਪੰਜਾਬੀ ਸਾਹਿਤ ਕੋਸ਼ (ਭਾਗ ਦੂਜਾ), ਪਬਲੀਕੇਸ਼ਨ ਬਿਊਰੋ, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ਦੂਜੀ ਛਾਪ, ੨੦੦੦',
    bibliography30:'ਸੁਰਿੰਦਰ ਸਿੰਘ ਕੋਹਲੀ (ਸੰਪਾ.), ਪੰਜਾਬੀ ਸਾਹਿਤ ਕੋਸ਼ (ਭਾਗ ਪਹਿਲਾ), ਪਬਲੀਕੇਸ਼ਨ ਬਿਊਰੋ, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ਦੂਜੀ ਛਾਪ, ੨੦੦੦',
    bibliography31:'ਸੁਰਿੰਦਰ ਸਿੰਘ ਕੋਹਲੀ, ਪੰਜਾਬੀ-ਅਖਾਣ ਕੋਸ਼, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ੧੯੯੨',
    bibliography32:'ਸੂਰਤ ਸਿੰਘ (ਭਾਈ), ਸਿੱਖਾਂ ਦੀ ਭਗਤ ਮਾਲਾ, ਸ.ਸ.ਪਦਮ (ਸੰਪਾ.), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੩',
    bibliography33:'ਸ਼ੇਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਗੁਰਮਤਿ ਦਰਸ਼ਨ, ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ਅਠਵੀਂ ਛਾਪ, ੨੦੦੪',
    bibliography34:'ਸੈਦੋ ਜੱਟ, ਸਾਖੀ ਬਾਬੇ ਨਾਨਕ ਜੀ ਕੀ (ਪੁਰਾਤਨ ਜਨਮਸਾਖੀ), ਸ.ਸ.ਪਦਮ (ਸੰਪਾ.), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮',
    bibliography35:'ਸ੍ਵਰੂਪ ਸਿੰਘ ਕੌਸ਼ਿਸ਼ (ਭਾਈ), ਗੁਰੂ ਕੀਆਂ ਸਾਖੀਆਂ, ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.) (ਸੰਪਾ.), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਛੇਵੀਂ ਛਾਪ, ੨੦੦੮',
    bibliography36:'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਸਾਡੀ ਭਾਸ਼ਾ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੪',
    bibliography37:'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਗੁਰਬਾਣੀ ਦਾ ਸੁੱਧ ਉਚਾਰਨ, ਚੀਫ ਖਾਲਸਾ ਦੀਵਾਨ, ਅੰਮ੍ਰਿਤਸਰ, ਦੂਜੀ ਛਾਪ, ੨੦੧੩',
    bibliography38:'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਗੁਰਬਾਣੀ ਦੀ ਭਾਸ਼ਾ ਤੇ ਵਿਆਕਰਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੨੦੧੬',
    bibliography39:'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬੀ ਸ਼ਬਦ ਰੂਪ ਤੇ ਸ਼ਬਦ ਜੋੜ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੮੮',
    bibliography40:'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬੀ ਬਾਰੇ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੬੬',
    bibliography41:'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਭਾਸ਼ਾ ਤੇ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਲਾਹੌਰ ਬੁਕ ਸ਼ਾਪ, ਲੁਧਿਆਣਾ, ਛੇਵੀਂ ਛਾਪ, ੨੦੧੭',
    bibliography42:'ਹਰਜਿੰਦਰ ਸਿੰਘ ਦਿਲਗੀਰ (ਡਾ.), ਦਿਲਗੀਰ ਕੋਸ਼, ਸਿਖ ਯੂਨੀਵਰਸਿਟੀ ਪ੍ਰੈਸ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮',
    bibliography43:'ਹਰਪਾਲ ਸਿੰਘ ਪੰਨੂ, ਰਾਜੇਸ਼ ਰੰਜਨ (ਸੰਪਾ.), ਨਾਗਸੇਨ ਕ੍ਰਿਤ ਮਿਲਿੰਦ ਪ੍ਰਸ਼ਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੨',
    bibliography44:'ਹਰਬੰਸ ਸਿੰਘ (ਗਿ.), ਆਦਿ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਦਰਸ਼ਨ ਨਿਰਣੈ ਸਟੀਕ (ਚੌਦਾਂ ਭਾਗ), ਗੁਰਬਾਣੀ ਸੇਵਾ ਪ੍ਰਕਾਸ਼ਨ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੧੩',
    bibliography45:'ਹਰਬੰਸ ਸਿੰਘ (ਗਿਆਨੀ), ਨਵੀਨ ਗੁਰਬਾਣੀ ਵਿਆਕਰਣ, ਗੁਰਬਾਣੀ ਸੇਵਾ ਪ੍ਰਕਾਸ਼ਨ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੧੨',
    bibliography46:'ਕਪੂਰ ਸਿੰਘ (ਸਿਰਦਾਰ), ਰਾਜ ਕਰੇਗਾ ਖਾਲਸਾ, ਗੁਰਮੁਖ ਸਿੰਘ (ਸੰਪਾ.), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੭',
    bibliography47:'ਕਪੂਰ ਸਿੰਘ ਘੁੰਮਣ, ਪੰਜਾਬੀ ਵਿਸ਼ਵ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੮੩',
    bibliography48:'ਕਰਤਾਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਆਸਾ ਦੀ ਵਾਰ ਸਟੀਕ, ਲਾਹੌਰ ਬੁਕ ਛਾਪ, ਲੁਧਿਆਣਾ, ੧੯੬੫',
    bibliography49:'ਕਰਤਾਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਦਰਪਣ (ਭਾਗ ਤੀਜਾ), ਧਰਮ ਪ੍ਰਚਾਰ ਕਮੇਟੀ, ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੦',
    bibliography50:'ਕਰਤਾਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਦਰਪਣ (ਭਾਗ ਦੂਜਾ), ਧਰਮ ਪ੍ਰਚਾਰ ਕਮੇਟੀ, ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੯',
    bibliography51:'ਕਰਤਾਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਦਰਪਣ (ਭਾਗ ਪਹਿਲਾ), ਧਰਮ ਪ੍ਰਚਾਰ ਕਮੇਟੀ, ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੩',
    bibliography52:'ਕਰਤਾਰ ਸਿੰਘ ਦਾਖਾ (ਪੰਡਤ), ਸ੍ਰੀ ਗੁਰੂ ਵਿਆਕਰਣ ਪੰਚਾਇਣ, ਪੰਡਿਤ ਕਰਤਾਰ ਸਿੰਘ ਜੀ, ਦਾਖਾ, ੧੯੪੫',
    bibliography53:'ਕਾਨ੍ਹ ਸਿੰਘ ਨਾਭਾ (ਭਾਈ), ਗੁਰੁਛੰਦ ਦਿਵਾਕਰ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੧',
    bibliography54:'ਕਾਲਾ ਸਿੰਘ ਬੇਦੀ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੧',
    bibliography55:'ਕਾਲਾ ਸਿੰਘ ਬੇਦੀ, ਲਿਪੀ ਦਾ ਵਿਕਾਸ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੫',
    bibliography56:'ਕਿਰਪਾਲ ਸਿੰਘ (ਸੰਤ), ਆਦਿ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਦਾ ਸੰਪਰਦਾਈ ਟੀਕਾ ਸ੍ਰੀ ਅਮੀਰ ਭੰਡਾਰ (ਭਾਗ ਪਹਿਲਾ), ਭਾਈ ਚਤਰ ਸਿੰਘ ਜੀਵਨ ਸਿੰਘ, ਅੰਮ੍ਰਿਤਸਰ, ਉਨੀਵੀਂ ਛਾਪ, ੨੦੧੩',
    bibliography57:'ਕਿਰਪਾਲ ਸਿੰਘ (ਗਿ.), ਸਮ ਅਰਥ ਕੋਸ਼, ਭਾਈ ਚਤਰ ਸਿੰਘ ਜੀਵਨ ਸਿੰਘ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੬੯',
    bibliography58:'ਕਿਰਪਾਲ ਸਿੰਘ (ਡਾ.) ਤੇ ਸ਼ਮਸ਼ੇਰ ਸਿੰਘ ਅਸ਼ੋਕ (ਸੰਪਾ.), ਜਨਮ ਸਾਖੀ ਸ੍ਰੀ ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ, ਸੈਂਚੀ ਦੂਜੀ (ਪੋਥੀ ਹਰਿਜੀ ਤੇ ਪੋਥੀ ਚਤੁਰਭੁਜ), ਖਾਲਸਾ ਕਾਲਜ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੬੯',
    bibliography59:'ਕ੍ਰਿਪਾਲ ਸਿੰਘ (ਗਿ.), ਸੰਪ੍ਰਦਾਈ ਟੀਕਾ ਸ੍ਰੀ ਅਮੀਰ ਭੰਡਾਰ, ਭਾਈ ਚਤਰ ਸਿੰਘ ਜੀਵਨ ਸਿੰਘ, ਅੰਮ੍ਰਿਤਸਰ, ਅਠ੍ਹਾਰਵੀਂ ਛਾਪ, ੨੦੧੧',
    bibliography60:'ਗਿਆਨ ਸਿੰਘ ਐਬਟਾਬਾਦ (ਸ.), ਗੁਰਬਾਣੀ ਸੰਗੀਤ (ਭਾਗ ਪਹਿਲਾ), ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੦',
    bibliography61:'ਗਿਆਨ ਸਿੰਘ ਐਬਟਾਬਾਦ (ਸ.), ਗੁਰਬਾਣੀ ਸੰਗੀਤ (ਭਾਗ ਦੂਜਾ), ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੬',
    bibliography62:'ਗੁਰਚਰਨ ਸਿੰਘ (ਡਾ.), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਕੋਸ਼, ਪ੍ਰੋ. ਸਾਹਿਬ ਸਿੰਘ ਟਰੱਸਟ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography63:'ਗੁਰਚਰਨ ਸਿੰਘ ਤਲਵਾੜਾ (ਪ੍ਰੋ.), ਸੂਫ਼ੀਮਤ ਸੰਕਲਪ ਕੋਸ਼, ਵਾਰਿਸ਼ ਸ਼ਾਹ ਫਾਊਂਡੇਸ਼ਨ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੬',
    bibliography64:'ਗੁਰਦਿੱਤ ਸਿੰਘ (ਗਿਆਨੀ), ਇਤਿਹਾਸ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ: ਭਗਤ ਬਾਣੀ ਭਾਗ, ਸਾਹਿਤ ਪ੍ਰਕਾਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ਦੂਜੀ ਛਾਪ, ੨੦੦੦',
    bibliography65:'ਗੁਰਦਿੱਤ ਸਿੰਘ (ਗਿਆਨੀ), ਇਤਿਹਾਸ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ: ਮੁੰਦਾਵਣੀ, ਸਾਹਿਤ ਪ੍ਰਕਾਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ੨੦੦੩',
    bibliography66:'ਗੁਰਨਾਮ ਸਿੰਘ (ਡਾ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਪਰਬੰਧ ਤੇ ਪਾਸਾਰ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography67:'ਗੁਰਨਾਮ ਸਿੰਘ (ਡਾ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਪਰਬੰਧ ਤੇ ਪਾਸਾਰ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography68:'ਗੁਲਵੰਤ ਸਿੰਘ, ਪੰਜਾਬੀ-ਫ਼ਾਰਸੀ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੮',
    bibliography69:'ਜਸਬੀਰ ਸਿੰਘ ਆਹਲੂਵਾਲੀਆ (ਡਾ.), ਇੱਕੀਵੀਂ ਸਦੀ ਦੇ ਸੰਦਰਭ ਵਿਚ ਸਿੱਖ ਫਲਸਫ਼ਾ, ਰਘਬੀਰ ਰਚਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ੧੯੯੯',
    bibliography70:'ਜਸਵੰਤ ਸਿੰਘ ਨੇਕੀ, ਗੁਰਮਤਿ ਮਨੋਵਿਗਿਆਨ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੯',
    bibliography71:'ਜੀ. ਐਸ. ਰਿਆਲ, ਸ਼ਬਦਾਂ ਦੀ ਪੈੜ, ਸੇਧ ਪ੍ਰਕਾਸ਼ਨ, ਪਟਿਆਲਾ, ੧੯੮੪',
    bibliography72:'ਜੀ. ਐਸ. ਰਿਆਲ, ਸਾਡੀ ਧਰਤੀ ਸਾਡੇ ਬੋਲ, ਪੰਜਾਬ ਸਟੇਟ ਯੂਨੀਵਰਸਿਟੀ ਟੈਕਸਟ ਬੁਕ ਬੋਰਡ, ਚੰਡੀਗੜ੍ਹ, ੧੯੮੯',
    bibliography73:'ਜੀ. ਐਸ. ਰਿਆਲ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਦਾ ਨਿਰੁਕਤ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੬',
    bibliography74:'ਜੀ. ਬੀ. ਸਿੰਘ, ਗੁਰਮੁਖੀ ਲਿਪੀ ਦਾ ਜਨਮ ਤੇ ਵਿਕਾਸ, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ਪੰਜਵੀਂ ਛਾਪ, ੨੦੧੦',
    bibliography75:'ਜੀ.ਬੀ ਸਿੰਘ, ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਦੀਆਂ ਪ੍ਰਾਚੀਨ ਬੀੜਾਂ, ਮਾਡਰਨ ਪਬਲੀਕੇਸ਼ਨਜ਼, ਲਾਹੌਰ, ੧੯੪੪',
    bibliography76:'ਜੀਤ ਸਿੰਘ ਸੀਤਲ (ਡਾ.), ਫ਼ਾਰਸੀ ਪੰਜਾਬੀ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੬',
    bibliography77:'ਜੋਗਾ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬੀ ਕੋਸ਼ (ਸਕੂਲ ਪੱਧਰ), ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੧੬',
    bibliography78:'ਜੋਗਿੰਦਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਗੁਰਮੁਖੀ ਲਿਪੀ: ਸੋਮੇ ਤੇ ਵਿਕਾਸ, ਚੇਤਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਲੁਧਿਆਣਾ, ੨੦੧੭',
    bibliography79:'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਸਲੋਕ ਸਹਸਕ੍ਰਿਤੀ ਤੇ ਗਾਥਾ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਤੇਰ੍ਹਵੀਂ ਛਾਪ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮',
    bibliography80:'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਸਲੋਕ ਗੁਰੂ ਅੰਗਦ ਸਾਹਿਬ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਛੇਵੀਂ ਛਾਪ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੪',
    bibliography81:'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਬੋਧ (ਭਾਗ-੧) ਬਾਣੀ ਬਿਉਰਾ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੦੪',
    bibliography82:'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਬੋਧ (ਭਾਗ-੨) ਗੁਰਬਾਣੀ ਉਚਾਰਣ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੦੪',
    bibliography83:'ਜੋਗਿੰਦਰ ਸਿਘ ਤਲਵਾੜਾ (ਭਾਈ), ਗੁਰਬਾਣੀ ਦਾ ਸਰਲ ਵਿਆਕਰਣ-ਬੋਧ (ਦੋ ਭਾਗ), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੪',
    bibliography84:'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਜੈਤਸਰੀ ਕੀ ਵਾਰ ਅਤੇ ਵਾਰ ਮਾਰੂ ਡਖਣੇ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੧੦',
    bibliography85:'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਨਿਤਨੇਮ ਸਰਲ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਅੱਠਵੀਂ ਛਾਪ, ੨੦੧੮',
    bibliography86:'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਬਾਵਨ ਅਖਰੀ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਦੂਜੀ ਛਾਪ, ੨੦੦੬',
    bibliography87:'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਭੱਟਾਂ ਦੇ ਸਵਈਏ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੧੪',
    bibliography88:'ਜੋਗਿੰਦਰ ਸਿੰਘ ਪੁਆਰ, ਭਾਸ਼ਾ ਵਿਗਿਆਨ: ਸੰਕਲਪ ਅਤੇ ਦਿਸ਼ਾਵਾਂ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਅਕਾਦਮੀ, ਜਲੰਧਰ, ਪੰਜਵੀਂ ਛਾਪ, ੨੦੧੭',
    bibliography89:'ਜੋਧ ਸਿੰਘ (ਭਾਈ), ਸ੍ਰੀ ਕਰਤਾਰਪੁਰੀ ਬੀੜ ਦੇ ਦਰਸ਼ਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography90:'ਜੌਨ ਡੌਸਨ, ਹਿੰਦੂ ਮਿਥਿਹਾਸ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਚਉਥੀ ਛਾਪ, ੨੦੧੩',
    bibliography91:'ਤਰਲੋਚਨ ਸਿੰਘ (ਡਾ.), ਗੁਰਮੁਖੀ ਲਿਪੀ ਦਾ ਜਨਮ ਤੇ ਵਿਕਾਸ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੯',
    bibliography92:'ਤਾਰਾ ਸਿੰਘ (ਪ੍ਰੋ. ), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਰਾਗ ਰਤਨਾਵਲੀ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੧',
    bibliography93:'ਤੇਜਾ ਸਿੰਘ (ਪ੍ਰਿੰ.), ਆਸਾ ਦੀ ਵਾਰ, ਕੇਂਦਰੀ ਸਿੰਘ ਸਭਾ ਅਕੈਡਮੀ, ਚੰਡੀਗੜ, ੧੯੯੯',
    bibliography94:'ਤੇਜਾ ਸਿੰਘ (ਪ੍ਰਿੰ.), ਸ਼ਬਦਾਰਥ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਸ਼ਿਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮',
    bibliography95:'ਦਲਜੀਤ ਸਿੰਘ ਖਹਿਰਾ (ਡਾ.), ਕੋਸ਼ਕਾਰੀ ਅਤੇ ਪੰਜਾਬੀ ਕੋਸ਼ਕਾਰੀ, ਲੋਕਗੀਤ ਪ੍ਰਕਾਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ੨੦੦੯',
    bibliography96:'ਦੁਨੀ ਚੰਦ੍ਰ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਦਾ ਵਿਕਾਸ, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ੧੯੪੯',
    bibliography97:'ਨਰੈਣ ਸਿੰਘ (ਪੰਡਿਤ), ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਸਟੀਕ, ਵਜ਼ੀਰ ਹਿੰਦ ਪ੍ਰੈਸ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੩੬',
    bibliography98:'ਨਾਜ਼ੀਆ ਹਸਨ, ਸਿੰਧੀ ਭਾਸ਼ਾ ਦੇ ਬੁਨਿਆਦੀ ਤੱਤ, ਸਪਤਰਿਸ਼ੀ ਪਬਲੀਕੇਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ੨੦੧੭',
    bibliography99:'ਪਰਮਜੀਤ ਸਿੰਘ ਸਿਧੂ, ਮਾਨਵ ਵਿਗਿਆਨਕ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੦',
    bibliography100:'ਪਿਆਰ ਸਿੰਘ, ਗਾਥਾ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ (ਪ੍ਰਾਚੀਨ ਹੱਥ-ਲਿਖਤ ਪੋਥੀਆਂ ਅਤੇ ਬੀੜਾਂ ਦੇ ਅਧਾਰ ‘ਤੇ), ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੯੨',
    bibliography101:'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਪ੍ਰਕਾਸ਼, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੦੪',
    bibliography102:'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਗੁਰਬਾਣੀ ਕੋਸ਼, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੬੦',
    bibliography103:'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਗੁਰੂ ਗ੍ਰੰਥ ਸੰਕੇਤ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੮੭',
    bibliography104:'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਗੁਰੂ ਗ੍ਰੰਥ ਵਿਚਾਰ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੨੦੧੧',
    bibliography105:'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਗੁਰੂ ਨਾਨਕ ਸਾਗਰ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਦੂਜੀ ਛਾਪ, ੨੦੧੯',
    bibliography106:'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਪੰਜਾਬੀ ਬੋਲੀ ਦਾ ਇਤਿਹਾਸ, ਕਲਮ ਮੰਦਿਰ ਲੋਇਰ ਮਾਲ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੧੯੯੫',
    bibliography107:'ਪੀ. ਡੀ. ਗੁਣੇ (ਡਾ.), ਤੁਲਨਾਤਮਕ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੦੧',
    bibliography108:'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.) (ਸੰਕਲਨ ਤੇ ਸੰਪਾ.), ਅਹੀਆਪੁਰ ਵਾਲੀ ਪੋਥੀ (ਭਾਗ ਦੂਜਾ), (ਦੋ ਭਾਗ), ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੨',
    bibliography109:'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.) (ਸੰਪਾ.), ਅਹੀਆਪੁਰ ਵਾਲੀ ਪੋਥੀ (ਭਾਗ ਪਹਿਲਾ), ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੯੮',
    bibliography110:'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.) (ਸੰਪਾ.), ਪਹਿਲੀ ਪਾਤਸ਼ਾਹੀ: ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ, ਪੰਜਾਬੀ ਸਾਹਿਤ ਅਕਾਡਮੀ, ਲੁਧਿਆਣਾ, ੧੯੬੯',
    bibliography111:'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.) ਤੇ ਜੋਗਿੰਦਰ ਸਿੰਘ ਆਹਲੂਵਾਲੀਆ (ਡਾ.), ਸਿੱਖਾਂ ਦਾ ਛੋਟਾ ਮੇਲ: ਇਤਿਹਾਸ ਤੇ ਸਰਵੇਖਣ, ਪੰਜਾਬੀ ਐਜੂਕੇਸ਼ਨਲ ਐਂਡ ਕਲਚਰਲ ਫ਼ਾਊਂਡੇਸ਼ਨ, ਸੈਨ ਲਿਐਂਡਰੋ, ਕੈਲੀਫੋਰਨੀਆਂ, ੨੦੦੯',
    bibliography112:'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.), (ਸੰਪਾ.), ਸਿੱਖ ਫਲਸਫੇ ਦੀ ਰੂਪ ਰੇਖਾ, ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੧,',
    bibliography113:'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.), ਪੰਜਾਬ, ਪੰਜਾਬੀ, ਪੰਜਾਬੀਅਤ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੯੮',
    bibliography114:'ਪ੍ਰੇਮ ਪ੍ਰਕਾਸ਼ ਸਿੰਘ (ਡਾ.), ਸਿਧਾਂਤਕ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਮਦਾਨ ਪਬਲੀਕੇਸ਼ਨਜ਼, ਪਟਿਆਲਾ, ੨੦੧੭',
    bibliography115:'ਪ੍ਰੇਮ ਪ੍ਰਕਾਸ਼ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਦਾ ਸਰੋਤ ਤੇ ਬਣਤਰ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੬',
    bibliography116:'ਪ੍ਰੇਮ ਪ੍ਰਕਾਸ਼ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਦਾ ਜਨਮ ਤੇ ਵਿਕਾਸ, ਮਦਾਨ ਪਬਲੀਕੇਸ਼ਨਜ਼, ਪਟਿਆਲਾ, ੨੦੧੭',
    bibliography117:'ਬਦਨ ਸਿੰਘ (ਗਿ.), ਆਦਿ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਸਟੀਕ (ਫਰੀਦਕੋਟ ਵਾਲਾ ਟੀਕਾ), (ਚਾਰ ਭਾਗ), ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੭੦',
    bibliography118:'ਬਲਕਾਰ ਸਿੰਘ, ਸਿੱਖ ਰਹੱਸਵਾਦ: ਅਨੁਭੂਤੀ ਅਤੇ ਅਭਿਵਿਅਕਤੀ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣਤਾਮਕ ਅਧਿਐਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੯',
    bibliography119:'ਬਲਦੇਵ ਸਿੰਘ ਚੀਮਾ (ਡਾ.), ਗੁਰਬਾਣੀ ਦਾ ਸਰਬਾਂਗੀ ਵਿਆਕਰਨ, ਚੇਤਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਲੁਧਿਆਣਾ, ੨੦੧੪',
    bibliography120:'ਬਲਵੰਤ ਸਿੰਘ ਢਿੱਲੋਂ (ਡਾ.), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਅਰਬੀ-ਫ਼ਾਰਸੀ ਸ਼ਬਦਾਵਲੀ ਕੋਸ਼, ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੪',
    bibliography121:'ਬਲਵਿੰਦਰ ਸਿੰਘ, ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਦੇ ਕੁੰਜੀਵਤ ਸ਼ਬਦ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੦',
    bibliography122:'ਬਲਵੀਰ ਸਿੰਘ (ਡਾ.), ਨਿਰੁਕਤ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ (ਛੇ ਭਾਗ), ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੭੨',
    bibliography123:'ਬਾਬੂ ਰਾਮ ਸਕਸੈਨਾ, ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੦੧',
    bibliography124:'ਬੁਧ ਸਿੰਘ (ਸ.), ਪੋਠੋਹਾਰੀ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੨੦੦੧',
    bibliography125:'ਭਗਤ ਸਿੰਘ ਹੀਰਾ, ਗੁਰਮਤਿ ਵਿਚਾਰਧਾਰਾ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੨੦',
    bibliography126:'ਮਹਿਤਾਬ ਸਿੰਘ (ਮਾਸਟਰ), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਵਿਚ ਆਏ ਇਤਿਹਾਸਕ ਨਾਵਾਂ ਤੇ ਥਾਵਾਂ ਦਾ ਕੋਸ਼, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਸਤਵੀਂ ਛਾਪ, ੨੦੧੦',
    bibliography127:'ਮਹਿੰਦਰ ਸਿੰਘ ਰਤਨ (ਡਾ.), ਗੁਰਮਤਿ ਦਰਸ਼ਨ ਵਿਚ ੴ ਦਾ ਸੰਕਲਪ, ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਮਿਸ਼ਨ ਪਟਿਆਲਾ, ਮਿਤੀਹੀਨ',
    bibliography128:'ਮਦਨ ਲਾਲ ਹਸੀਜਾ (ਡਾਇਰੈਕਟਰ), ਉਰਦੂ-ਪੰਜਾਬੀ-ਹਿੰਦੀ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੯੭',
    bibliography129:'ਮਨਜੀਤ ਸਿੰਘ (ਭਾਈ), ਆਸਾ ਕੀ ਵਾਰ ਸਰਲ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੯',
    bibliography130:'ਮਨਮੰਦਰ ਸਿੰਘ, ਮਲਵਈ ਸ਼ਬਦ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੧੬',
    bibliography131:'ਮਨਮੋਹਨ ਸਹਿਗਲ (ਡਾ.), ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਇਕ ਸਭਿਆਚਾਰਕ ਸਰਵੇਖਣ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੮੭',
    bibliography132:'ਮਨੀ ਸਿੰਘ (ਗਿ.), ਸਿਧਾਂਤਕ ਸਟੀਕ, ਗੁਰਬਾਣੀ ਸਟੱਡੀਜ਼ ਸੁਸਾਇਟੀ, ਕਨੇਡਾ, ੧੯੯੩',
    bibliography133:'ਮਨੋਹਰ ਸਿੰਘ ਮਾਰਕੋ, ਹੱਥ-ਲਿਖਤ ਪ੍ਰਾਚੀਨ ਬੀੜਾਂ ਦੀ ਪਰਿਕਰਮਾ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੧',
    bibliography134:'ਮਿਹਰਬਾਨ ਜੀ ਸੋਢੀ, ਜਨਮਸਾਖੀ ਸ੍ਰੀ ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ, ਕਿਰਪਾਲ ਸਿੰਘ ਤੇ ਸਮਸ਼ੇਰ ਸਿੰਘ ਅਸ਼ੋਕ (ਸੰਪਾ.), ਖਾਲਸਾ ਕਾਲਜ, ਅੰਮ੍ਰਿਤਸਰ,੧੯੬੨',
    bibliography135:'ਮੁਹੱਮਦ ਹੁਸੈਨ ਆਜ਼ਾਦ, ਸੁਖ਼ਨ ਦਾਨਿ ਫ਼ਾਰਿਸ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੬੩',
    bibliography136:'ਮੁਹਾਉੱਦੀਨ ਕਾਦਰੀ ਜ਼ੋਰ (ਡਾ.), ਭਾਰਤੀ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੬੩',
    bibliography137:'ਮੈਕਸ ਆਰਥਰ ਮੈਕਾਲਿਫ, ਸਿਖ ਇਤਿਹਾਸ, (ਭਾਗ ਪਹਿਲਾ ਤੇ ਦੂਜਾ), ਲਾਹੌਰ ਬੁਕ ਸ਼ਾਪ, ਲੁਧਿਆਣਾ, ੨੦੧੪',
    bibliography138:'ਰਣਜੀਤ ਸਿੰਘ ਖੜਗ, ਨਾਨਕ ਸ਼ਾਇਰ ਇਵ ਕਹਿਆ, ਚੇਤਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਲੁਧਿਆਣਾ, ੨੦੧੦',
    bibliography139:'ਰਣਧੀਰ ਸਿੰਘ (ਭਾਈ), ਗੁਰਬਾਣੀ ਦੀਆਂ ਲਗਾਂ ਮਾਤ੍ਰਾਂ ਦੀ ਵਿਲੱਖਣਤਾ, ਭਾਈ ਰਣਧੀਰ ਸਿੰਘ ਪਬਲਿਸ਼ਿੰਗ ਹਾਊਸ, ਲੁਧਿਆਣਾ, ਦੂਜੀ ਛਾਪ, ੧੯੮੭',
    bibliography140:'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.) (ਸੰਪਾ.), ਸਾਹਿਤ ਕੋਸ਼: ਪਰਿਭਾਸ਼ਿਕ ਸ਼ਬਦਾਵਲੀ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੧',
    bibliography141:'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਅੰਤਿਕਾ ਭਾਵ ਪ੍ਰਬੋਧਨੀ ਟੀਕਾ: ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੫',
    bibliography142:'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਅਰਥ ਬੋਧ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਆਰਸੀ ਪਬਲਿਸ਼ਰਜ਼, ਦਿੱਲੀ, ੨੦੦੭',
    bibliography143:'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਆਸਾ ਦੀ ਵਾਰ: ਵਿਸ਼ਲੇਸ਼ਣ ਅਤੇ ਵਿਆਖਿਆ, ਗੁਰਮਤਿ ਪ੍ਰਕਾਸ਼ਨ ਪਟਿਆਲਾ, ੨੦੧੭',
    bibliography144:'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਇਤਿਹਾਸ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੮',
    bibliography145:'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਗੁਰੂ ਗ੍ਰੰਥ ਵਿਸ਼ਵਕੋਸ਼ (ਭਾਗ ਪਹਿਲਾ ਤੇ ਦੂਜਾ), ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੨',
    bibliography146:'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਗੁਰੂ ਨਾਨਕ: ਵਿਅਕਤਿਤ੍ਵ ਕਰਤਿਤ੍ਵ ਅਤੇ ਚਿੰਤਨ, ਭਾਸ਼ਾ ਵਿਭਾਗ, ਪੰਜਾਬ, ੧੯੭੫',
    bibliography147:'ਰਾਜਿੰਦਰ ਸਿੰਘ ਲਾਂਬਾ (ਡਾ.), ਉਰਦੂ-ਪੰਜਾਬੀ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੫',
    bibliography148:'ਲਾਲ ਸਿੰਘ (ਡਾਇਰੈਕਟਰ), ਪੰਜਾਬੀ ਅਤੇ ਉੱਤਰ-ਭਾਰਤੀ ਭਾਸ਼ਾਵਾਂ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੭੦',
    bibliography149:'ਲਾਲ ਸਿੰਘ (ਡਾਇਰੈਕਟਰ), ਪੰਜਾਬੀ ਕੋਸ਼ (ਛੇ ਭਾਗ), ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੧੯੯੦',
    bibliography150:'ਓਮ ਪ੍ਰਕਾਸ਼ ਵਸ਼ਿਸ਼ਟ, ਕੋਸ਼ ਵਿਗਿਆਨ ਅਤੇ ਪੰਜਾਬੀ ਕੋਸ਼ਕਾਰੀ, ਨੈਨਸੀ ਪਬਲਿਸ਼ਰਜ਼, ਚੰਡੀਗੜ੍ਹ, ੧੯੯੨',
    bibliography151:'ਵਜ਼ੀਰ ਸਿੰਘ, ਧਰਮ ਦਾ ਦਾਰਸ਼ਨਿਕ ਪੱਖ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੯',
    bibliography152:'ਵੀਰ ਸਿੰਘ (ਭਾਈ), ਸੰਥ੍ਯਾ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, (ਸੱਤ ਭਾਗ), ਡਾ. ਬਲਬੀਰ ਸਿੰਘ (ਸੰਪਾ.), ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਪੰਜਵੀਂ ਛਾਪ, ੧੯੯੩',
    bibliography153:'ਵੀਰ ਸਿੰਘ (ਭਾਈ), ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਕੋਸ਼, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਸਤਵੀਂ ਛਾਪ, ੨੦੦੩',
    bibliography154:'ਵੇਦ ਅਗਨੀਹੋਤਰੀ, ਪਰਿਚਾਇਕ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਦੀਪਕ ਪਬਲੀਸ਼ਰਜ਼, ਜਲੰਧਰ, ੧੯੯੮',
   

    /*bibliography1:
      'ਓਅੰਕਾਰ ਸਿੰਘ (ਸ.), ਪੋਠੋਹਾਰੀ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੦੧',
    bibliography2:
      'ਓਮਕਾਰ ਨਾਥ ਕੌਲ (ਡਾ.), ਪੰਜਾਬੀ ਕਸ਼ਮੀਰੀ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੯੯',
    bibliography3:
      'ਅਕਾਲੀ ਕੌਰ ਸਿੰਘ, ਗੁਰੁ ਸ਼ਬਦ ਰਤਨ ਪ੍ਰਕਾਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੧੯੮੬',
    bibliography4:
      'ਅਗਿਆਤ, ਗੁਰਮਤਿ ਸੰਗੀਤ, ਧਰਮ ਪ੍ਰਚਾਰ ਕਮੇਟੀ, ਸੈਂਟਰਲ ਖ਼ਾਲਸਾ ਯਤੀਮਖ਼ਾਨਾ (ਚੀਫ਼ ਖ਼ਾਲਸਾ ਦੀਵਾਨ), ਜੀ. ਟੀ. ਰੋਡ, ਅੰਮ੍ਰਿਤਸਰ, ਦੂਜੀ ਛਾਪ, ੨੦੦੮',
    bibliography5:
      'ਅਮਰ ਸਿੰਘ ਚਾਕਰ (ਸ.) (ਸੰਪਾ.), ਵਾਰਾਂ ਭਾਈ ਗੁਰਦਾਸ, ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ਸਤਵੀਂ ਛਾਪ, ੧੯੯੮',
    bibliography6:
      'ਅਮਰਵੰਤ ਸਿਘ (ਡਾ.), ਅਰਬੀ-ਫ਼ਾਰਸੀ ਵਿਚੋਂ ਉਤਪੰਨ ਪੰਜਾਬੀ ਸ਼ਬਦਾਵਲੀ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੩',
    bibliography7:
      'ਅੰਮ੍ਰਿਤਪਾਲ ਕੌਰ (ਪ੍ਰੋ.) (ਸੰਪਾ.), ਖੋਜ ਪਤ੍ਰਿਕਾ (ਬਾਣੀ ਕਾਵਿ ਰੂਪ ਵਿਸ਼ੇਸ਼ ਅੰਕ), ਅੰਕ ੫੮, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੩',
    bibliography8:
      'ਅਲੰਕਾਰ ਸਿੰਘ (ਅਨੁ. ਅਤੇ ਸੰਪਾ.), ਹਿੰਦੁਸਤਾਨੀ ਸੰਗੀਤ: ਵਿਭਿੰਨ ਪਰਿਪੇਖ, ਗਰੇਸ਼ੀਅਸ ਬੁਕਸ, ਪਟਿਆਲਾ, ੨੦੦੯',
    bibliography9:
      'ਅਵਤਾਰ ਸਿੰਘ (ਭਾਈ) ਤੇ ਗੁਰਚਰਨ ਸਿੰਘ (ਭਾਈ), ਗੁਰਬਾਣੀ ਸੰਗੀਤ ਪ੍ਰਾਚੀਨ ਰੀਤ ਰਤਨਾਵਲੀ (ਦੋ ਭਾਗ) ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਚੌਥੀ ਛਾਪ, ੨੦੧੬',
    bibliography10:
      'ਐਸ. ਐਸ. ਕਿਸ਼ਨਪੁਰੀ (ਡਾ.), ਪੁਆਧੀ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੦੮',
    bibliography11:
      'ਇੰਦਰਮੋਹਨ ਸਿੰਘ (ਪ੍ਰੋ.), ਪੰਜਾਬੀ ਸੰਸਕ੍ਰਿਤ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੭',
    bibliography12:
      'ਸੰਤਾ ਸਿੰਘ ਤਤਲੇ, ਗੁਰਬਾਣੀ ਤੱਤ ਸਾਰ (ਛੇ ਭਾਗ), ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੧੫',
    bibliography13:
      'ਸਤਿਬੀਰ ਸਿੰਘ (ਪ੍ਰਿੰ.), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਦਾ ਸਾਰ-ਵਿਸਥਾਰ, ਨਿਊ ਬੁੱਕ ਕੰਪਨੀ, ਜਲੰਧਰ, ੧੯੮੭',
    bibliography14:
      'ਸੱਯਦ ਅਬੁਲ ਆਲਾ ਮੌਦੂਦੀ, ਕੁਰਆਨ ਮਜੀਦ: ਅਨੁਵਾਦ ਤੇ ਸੰਖੇਪ ਟੀਕਾ ਸਹਿਤ, ਰਮਜ਼ਾਨ ਸਈਦ, (ਪੰਜਾਬੀ ਅਨੁ.), ਪੰਜਾਬੀ ਇਸਲਾਮਿਕ ਪਬਲੀਕੇਸ਼ਨਜ਼, ਮਲੇਰਕੋਟਲਾ, ੨੦੧੩',
    bibliography15:
      'ਸਰਦੂਲ ਸਿੰਘ ਕਵੀਸ਼ਰ, ਸਿੱਖ ਧਰਮ ਦਰਸ਼ਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੧੯੯੩',
    bibliography16:
      'ਸਰਬਜਿੰਦਰ ਸਿੰਘ (ਡਾ.) (ਸੰਪਾ.), ਨਾਨਕ ਪ੍ਰਕਾਸ਼ ਪਤ੍ਰਿਕਾ, ਅੰਕ ਦੂਜਾ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੧',
    bibliography17:
      'ਸਾਹਿਬ ਸਿੰਘ (ਪ੍ਰੋ.), ਆਦਿ ਬੀੜ ਬਾਰੇ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੯੯',
    bibliography18:
      'ਸਾਹਿਬ ਸਿੰਘ (ਪ੍ਰੋ.), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਦਰਪਣ (ਦਸ ਪੋਥੀਆਂ), ਰਾਜ ਪਬਲਿਸ਼ਰਜ਼, ਜਲੰਧਰ, ੧੯੬੨',
    bibliography19:
      'ਸਾਹਿਬ ਸਿੰਘ (ਪ੍ਰੋ.), ਗੁਰਬਾਣੀ ਵਿਆਕਰਣ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਉਨ੍ਹੀਵੀਂ ਛਾਪ, ੨੦੧੫',
    bibliography20:
      'ਸ਼ਾਮ ਸਿੰਘ, ਪ੍ਰਯਾਇ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਭਾਈ ਨਰੈਣ ਸਿੰਘ ਐਂਗਲੋ ਉਰਦੂ ਐਂਡ ਗੁਰਮੁਖੀ ਪ੍ਰੈਸ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੦੬',
    bibliography21:
      'ਸੀਹਾਂ ਉਪਲ, ਸਾਖੀ ਮਹਲੁ ਪਹਿਲੇ ਕੀ, ਸ.ਸ.ਪਦਮ (ਸੰਪਾ.), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੪',
    bibliography22:
      'ਸੁਆਮੀ ਅਨੰਦਘਨ, ਆਸਾ ਦੀ ਵਾਰ ਦਾ ਟੀਕਾ (ਸੰਪਾਦਕ ਡਾ. ਰਤਨ ਸਿੰਘ ਜੱਗੀ), ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੯',
    bibliography23:
      'ਸੁਖਦਿਆਲ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬ ਦਾ ਇਤਿਹਾਸ: ਗੁਰੂ ਕਾਲ ੧੪੬੯-੧੫੩੯ (ਭਾਗ ਪੰਜਵਾਂ), ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography24:
      'ਸੁਖਵੰਤ ਸਿੰਘ (ਭਾਈ ), ਗੁਰੂ ਨਾਨਕ ਸੰਗੀਤ ਪੱਧਤੀ ਗ੍ਰੰਥ, ਗੁਰਦੁਆਰਾ ਗੁਰ ਗਿਆਨ ਪ੍ਰਕਾਸ਼, ਜਵੱਦੀ ਟਕਸਾਲ, ਲੁਧਿਆਣਾ, ਮਿਤੀ ਹੀਣ',
    bibliography25:
      'ਸੁਖਵੰਤ ਸਿੰਘ (ਭਾਈ ), ਗੁਰੂ ਨਾਨਕ ਸੰਗੀਤ ਪੱਧਤੀ ਗ੍ਰੰਥ, ਗੁਰਦੁਆਰਾ ਗੁਰ ਗਿਆਨ ਪ੍ਰਕਾਸ਼, ਜਵੱਦੀ ਟਕਸਾਲ, ਲੁਧਿਆਣਾ, ਮਿਤੀ ਹੀਣ',
    bibliography26:
      'ਸੁਖਵਿੰਦਰ ਸਿੰਘ ਸੰਘਾ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਅਕਾਦਮੀ, ਜਲੰਧਰ, ਦਸਵੀਂ ਛਾਪ, ੨੦੧੭',
    bibliography27:
      'ਸੁਤਿੰਦਰ ਸਿੰਘ ਨੂਰ, ੴ ਵਿਕਾਸ ਅਤੇ ਸੰਕਲਪੀ ਚਿਹਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਟੀ, ਪਟਿਆਲਾ, ੨੦੧੨',
    bibliography28:
      'ਸੁਤੇ ਪ੍ਰਕਾਸ਼, ਪ੍ਰਯਾਇ ਆਦਿ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਭਾਈ ਹਰੀ ਸਿੰਘ ਲਿਖਾਰੀ ਬੁੰਗਾ ਸਿੰਘ ਪੁਰੀਆਂ, ਅੰਮ੍ਰਿਤਸਰ, ੧੮੯੬',
    bibliography29:
      'ਸੁਰਿੰਦਰ ਸਿੰਘ ਕੋਹਲੀ (ਸੰਪਾ.), ਪੰਜਾਬੀ ਸਾਹਿਤ ਕੋਸ਼ (ਭਾਗ ਤੀਜਾ), ਪਬਲੀਕੇਸ਼ਨ ਬਿਊਰੋ, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ੧੯੯੨',
    bibliography30:
      'ਸੁਰਿੰਦਰ ਸਿੰਘ ਕੋਹਲੀ (ਸੰਪਾ.), ਪੰਜਾਬੀ ਸਾਹਿਤ ਕੋਸ਼ (ਭਾਗ ਦੂਜਾ), ਪਬਲੀਕੇਸ਼ਨ ਬਿਊਰੋ, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ਦੂਜੀ ਛਾਪ, ੨੦੦੦',
    bibliography31:
      'ਸੁਰਿੰਦਰ ਸਿੰਘ ਕੋਹਲੀ (ਸੰਪਾ.), ਪੰਜਾਬੀ ਸਾਹਿਤ ਕੋਸ਼ (ਭਾਗ ਪਹਿਲਾ), ਪਬਲੀਕੇਸ਼ਨ ਬਿਊਰੋ, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ਦੂਜੀ ਛਾਪ, ੨੦੦੦',
    bibliography32:
      'ਸੁਰਿੰਦਰ ਸਿੰਘ ਕੋਹਲੀ, ਪੰਜਾਬੀ-ਅਖਾਣ ਕੋਸ਼, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ੧੯੯੨',
    bibliography33:
      'ਸੂਰਤ ਸਿੰਘ (ਭਾਈ), ਸਿੱਖਾਂ ਦੀ ਭਗਤ ਮਾਲਾ, ਸ.ਸ.ਪਦਮ (ਸੰਪਾ.), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੩',
    bibliography34:
      'ਸ਼ੇਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਗੁਰਮਤਿ ਦਰਸ਼ਨ, ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ਅਠਵੀਂ ਛਾਪ, ੨੦੦੪',
    bibliography35:
      'ਸੈਦੋ ਜੱਟ, ਸਾਖੀ ਬਾਬੇ ਨਾਨਕ ਜੀ ਕੀ (ਪੁਰਾਤਨ ਜਨਮਸਾਖੀ), ਸ.ਸ.ਪਦਮ (ਸੰਪਾ.), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮',
    bibliography36:
      'ਸ੍ਵਰੂਪ ਸਿੰਘ ਕੌਸ਼ਿਸ਼ (ਭਾਈ), ਗੁਰੂ ਕੀਆਂ ਸਾਖੀਆਂ, ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.) (ਸੰਪਾ.), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਛੇਵੀਂ ਛਾਪ, ੨੦੦੮',
    bibliography37:
      'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਸਾਡੀ ਭਾਸ਼ਾ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੪',
    bibliography38:
      'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਗੁਰਬਾਣੀ ਦਾ ਸੁੱਧ ਉਚਾਰਨ, ਚੀਫ ਖਾਲਸਾ ਦੀਵਾਨ, ਅੰਮ੍ਰਿਤਸਰ, ਦੂਜੀ ਛਾਪ, ੨੦੧੩',
    bibliography39:
      'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਗੁਰਬਾਣੀ ਦੀ ਭਾਸ਼ਾ ਤੇ ਵਿਆਕਰਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੨੦੧੬',
    bibliography40:
      'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬੀ ਸ਼ਬਦ ਰੂਪ ਤੇ ਸ਼ਬਦ ਜੋੜ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੮੮',
    bibliography41:
      'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬੀ ਬਾਰੇ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੬੬',
    bibliography42:
      'ਹਰਕੀਰਤ ਸਿੰਘ (ਡਾ.), ਭਾਸ਼ਾ ਤੇ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਲਾਹੌਰ ਬੁਕ ਸ਼ਾਪ, ਲੁਧਿਆਣਾ, ਛੇਵੀਂ ਛਾਪ, ੨੦੧੭',
    bibliography43:
      'ਹਰਜਿੰਦਰ ਸਿੰਘ ਦਿਲਗੀਰ (ਡਾ.), ਦਿਲਗੀਰ ਕੋਸ਼, ਸਿਖ ਯੂਨੀਵਰਸਿਟੀ ਪ੍ਰੈਸ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮',
    bibliography44:
      'ਹਰਜਿੰਦਰ ਸਿੰਘ ਦਿਲਗੀਰ (ਡਾ.), ਦਿਲਗੀਰ ਕੋਸ਼, ਸਿਖ ਯੂਨੀਵਰਸਿਟੀ ਪ੍ਰੈਸ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮',
    bibliography45:
      'ਹਰਪਾਲ ਸਿੰਘ ਪੰਨੂ, ਰਾਜੇਸ਼ ਰੰਜਨ (ਸੰਪਾ.), ਨਾਗਸੇਨ ਕ੍ਰਿਤ ਮਿਲਿੰਦ ਪ੍ਰਸ਼ਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੨',
    bibliography46:
      'ਹਰਬੰਸ ਸਿੰਘ (ਗਿ.), ਆਦਿ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਦਰਸ਼ਨ ਨਿਰਣੈ ਸਟੀਕ (ਚੌਦਾਂ ਭਾਗ), ਗੁਰਬਾਣੀ ਸੇਵਾ ਪ੍ਰਕਾਸ਼ਨ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੧੩',
    bibliography47:
      'ਹਰਬੰਸ ਸਿੰਘ (ਗਿਆਨੀ), ਨਵੀਨ ਗੁਰਬਾਣੀ ਵਿਆਕਰਣ, ਗੁਰਬਾਣੀ ਸੇਵਾ ਪ੍ਰਕਾਸ਼ਨ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੧੨',
    bibliography48:
      'ਕਪੂਰ ਸਿੰਘ (ਸਿਰਦਾਰ), ਰਾਜ ਕਰੇਗਾ ਖਾਲਸਾ, ਗੁਰਮੁਖ ਸਿੰਘ (ਸੰਪਾ.), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੭',
    bibliography49:
      'ਕਪੂਰ ਸਿੰਘ ਘੁੰਮਣ, ਪੰਜਾਬੀ ਵਿਸ਼ਵ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੮੩',
    bibliography50:
      'ਕਰਤਾਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਆਸਾ ਦੀ ਵਾਰ ਸਟੀਕ, ਲਾਹੌਰ ਬੁਕ ਛਾਪ, ਲੁਧਿਆਣਾ, ੧੯੬੫',
    bibliography51:
      'ਕਰਤਾਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਦਰਪਣ (ਭਾਗ ਤੀਜਾ), ਧਰਮ ਪ੍ਰਚਾਰ ਕਮੇਟੀ, ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੦',
    bibliography52:
      'ਕਰਤਾਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਦਰਪਣ (ਭਾਗ ਦੂਜਾ), ਧਰਮ ਪ੍ਰਚਾਰ ਕਮੇਟੀ, ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੯',
    bibliography53:
      'ਕਰਤਾਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਦਰਪਣ (ਭਾਗ ਪਹਿਲਾ), ਧਰਮ ਪ੍ਰਚਾਰ ਕਮੇਟੀ, ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੩',
    bibliography54:
      'ਕਰਤਾਰ ਸਿੰਘ ਦਾਖਾ (ਪੰਡਤ), ਸ੍ਰੀ ਗੁਰੂ ਵਿਆਕਰਣ ਪੰਚਾਇਣ, ਪੰਡਿਤ ਕਰਤਾਰ ਸਿੰਘ ਜੀ, ਦਾਖਾ, ੧੯੪੫',
    bibliography55:
      'ਕਰਤਾਰ ਸਿੰਘ ਦਾਖਾ (ਪੰਡਤ), ਸ੍ਰੀ ਗੁਰੂ ਵਿਆਕਰਣ ਪੰਚਾਇਣ, ਪੰਡਿਤ ਕਰਤਾਰ ਸਿੰਘ ਜੀ, ਦਾਖਾ, ੧੯੪੫',
    bibliography56:
      'ਕਾਨ੍ਹ ਸਿੰਘ ਨਾਭਾ (ਭਾਈ), ਗੁਰੁਛੰਦ ਦਿਵਾਕਰ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੧',
    bibliography57:
      'ਕਾਲਾ ਸਿੰਘ ਬੇਦੀ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੧',
    bibliography58:
      'ਕਾਲਾ ਸਿੰਘ ਬੇਦੀ, ਲਿਪੀ ਦਾ ਵਿਕਾਸ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੫',
    bibliography59:
      'ਕਿਰਪਾਲ ਸਿੰਘ (ਸੰਤ), ਆਦਿ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਦਾ ਸੰਪਰਦਾਈ ਟੀਕਾ ਸ੍ਰੀ ਅਮੀਰ ਭੰਡਾਰ (ਭਾਗ ਪਹਿਲਾ), ਭਾਈ ਚਤਰ ਸਿੰਘ ਜੀਵਨ ਸਿੰਘ, ਅੰਮ੍ਰਿਤਸਰ, ਉਨੀਵੀਂ ਛਾਪ, ੨੦੧੩',
    bibliography60:
      'ਕਿਰਪਾਲ ਸਿੰਘ (ਗਿ.), ਸਮ ਅਰਥ ਕੋਸ਼, ਭਾਈ ਚਤਰ ਸਿੰਘ ਜੀਵਨ ਸਿੰਘ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੬੯',
    bibliography61:
      'ਕਿਰਪਾਲ ਸਿੰਘ (ਡਾ.) ਤੇ ਸ਼ਮਸ਼ੇਰ ਸਿੰਘ ਅਸ਼ੋਕ (ਸੰਪਾ.), ਜਨਮ ਸਾਖੀ ਸ੍ਰੀ ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ, ਸੈਂਚੀ ਦੂਜੀ (ਪੋਥੀ ਹਰਿਜੀ ਤੇ ਪੋਥੀ ਚਤੁਰਭੁਜ), ਖਾਲਸਾ ਕਾਲਜ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੬੯',
    bibliography62:
      'ਕਿਰਪਾਲ ਸਿੰਘ (ਡਾ.) ਤੇ ਸ਼ਮਸ਼ੇਰ ਸਿੰਘ ਅਸ਼ੋਕ (ਸੰਪਾ.), ਜਨਮ ਸਾਖੀ ਸ੍ਰੀ ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ, ਸੈਂਚੀ ਦੂਜੀ (ਪੋਥੀ ਹਰਿਜੀ ਤੇ ਪੋਥੀ ਚਤੁਰਭੁਜ), ਖਾਲਸਾ ਕਾਲਜ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੬੯',
    bibliography63:
      'ਕਿਰਪਾਲ ਸਿੰਘ (ਡਾ.) ਤੇ ਸ਼ਮਸ਼ੇਰ ਸਿੰਘ ਅਸ਼ੋਕ (ਸੰਪਾ.), ਜਨਮ ਸਾਖੀ ਸ੍ਰੀ ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ, ਸੈਂਚੀ ਦੂਜੀ (ਪੋਥੀ ਹਰਿਜੀ ਤੇ ਪੋਥੀ ਚਤੁਰਭੁਜ), ਖਾਲਸਾ ਕਾਲਜ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੬੯',
    bibliography64:
      'ਕ੍ਰਿਪਾਲ ਸਿੰਘ (ਗਿ.), ਸੰਪ੍ਰਦਾਈ ਟੀਕਾ ਸ੍ਰੀ ਅਮੀਰ ਭੰਡਾਰ, ਭਾਈ ਚਤਰ ਸਿੰਘ ਜੀਵਨ ਸਿੰਘ, ਅੰਮ੍ਰਿਤਸਰ, ਅਠ੍ਹਾਰਵੀਂ ਛਾਪ, ੨੦੧੧',
    bibliography65:
      'ਕ੍ਰਿਪਾਲ ਸਿੰਘ (ਗਿ.), ਸੰਪ੍ਰਦਾਈ ਟੀਕਾ ਸ੍ਰੀ ਅਮੀਰ ਭੰਡਾਰ, ਭਾਈ ਚਤਰ ਸਿੰਘ ਜੀਵਨ ਸਿੰਘ, ਅੰਮ੍ਰਿਤਸਰ, ਅਠ੍ਹਾਰਵੀਂ ਛਾਪ, ੨੦੧੧',
    bibliography66:
      'ਗਿਆਨ ਸਿੰਘ ਐਬਟਾਬਾਦ (ਸ.), ਗੁਰਬਾਣੀ ਸੰਗੀਤ (ਭਾਗ ਪਹਿਲਾ), ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੦',
    bibliography67:
      'ਗਿਆਨ ਸਿੰਘ ਐਬਟਾਬਾਦ (ਸ.), ਗੁਰਬਾਣੀ ਸੰਗੀਤ (ਭਾਗ ਦੂਜਾ), ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੬',
    bibliography68:
      'ਗਿਆਨ ਸਿੰਘ ਐਬਟਾਬਾਦ (ਸ.), ਗੁਰਬਾਣੀ ਸੰਗੀਤ (ਭਾਗ ਦੂਜਾ), ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੬',
    bibliography69:
      'ਗਿਆਨ ਸਿੰਘ ਐਬਟਾਬਾਦ (ਸ.), ਗੁਰਬਾਣੀ ਸੰਗੀਤ (ਭਾਗ ਦੂਜਾ), ਸ਼੍ਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਸ੍ਰੀ ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੬',
    bibliography70:
      'ਗੁਰਚਰਨ ਸਿੰਘ (ਡਾ.), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਕੋਸ਼, ਪ੍ਰੋ. ਸਾਹਿਬ ਸਿੰਘ ਟਰੱਸਟ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography71:
      'ਗੁਰਚਰਨ ਸਿੰਘ ਤਲਵਾੜਾ (ਪ੍ਰੋ.), ਸੂਫ਼ੀਮਤ ਸੰਕਲਪ ਕੋਸ਼, ਵਾਰਿਸ਼ ਸ਼ਾਹ ਫਾਊਂਡੇਸ਼ਨ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੬',
    bibliography72:
      'ਗੁਰਚਰਨ ਸਿੰਘ ਤਲਵਾੜਾ (ਪ੍ਰੋ.), ਸੂਫ਼ੀਮਤ ਸੰਕਲਪ ਕੋਸ਼, ਵਾਰਿਸ਼ ਸ਼ਾਹ ਫਾਊਂਡੇਸ਼ਨ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੬',
    bibliography73:
      'ਗੁਰਦਿੱਤ ਸਿੰਘ (ਗਿਆਨੀ), ਇਤਿਹਾਸ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ: ਭਗਤ ਬਾਣੀ ਭਾਗ, ਸਾਹਿਤ ਪ੍ਰਕਾਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ਦੂਜੀ ਛਾਪ, ੨੦੦੦',
    bibliography74:
      'ਗੁਰਦਿੱਤ ਸਿੰਘ (ਗਿਆਨੀ), ਇਤਿਹਾਸ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ: ਮੁੰਦਾਵਣੀ, ਸਾਹਿਤ ਪ੍ਰਕਾਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ੨੦੦੩',
    bibliography75:
      'ਗੁਰਨਾਮ ਸਿੰਘ (ਡਾ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਪਰਬੰਧ ਤੇ ਪਾਸਾਰ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography76:
      'ਗੁਰਨਾਮ ਸਿੰਘ (ਡਾ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਪਰਬੰਧ ਤੇ ਪਾਸਾਰ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography77:
      'ਗੁਰਨਾਮ ਸਿੰਘ (ਡਾ.), ਗੁਰਮਤਿ ਸੰਗੀਤ ਪਰਬੰਧ ਤੇ ਪਾਸਾਰ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography78:
      'ਗੁਲਵੰਤ ਸਿੰਘ, ਪੰਜਾਬੀ-ਫ਼ਾਰਸੀ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੮',
    bibliography79:
      'ਜਸਬੀਰ ਸਿੰਘ ਆਹਲੂਵਾਲੀਆ (ਡਾ.), ਇੱਕੀਵੀਂ ਸਦੀ ਦੇ ਸੰਦਰਭ ਵਿਚ ਸਿੱਖ ਫਲਸਫ਼ਾ, ਰਘਬੀਰ ਰਚਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ੧੯੯੯',
    bibliography80:
      'ਜਸਵੰਤ ਸਿੰਘ ਨੇਕੀ, ਗੁਰਮਤਿ ਮਨੋਵਿਗਿਆਨ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੯',
    bibliography81:
      'ਜਸਵੰਤ ਸਿੰਘ ਨੇਕੀ, ਗੁਰਮਤਿ ਮਨੋਵਿਗਿਆਨ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੯',
    bibliography82: 'ਜੀ. ਐਸ. ਰਿਆਲ, ਸ਼ਬਦਾਂ ਦੀ ਪੈੜ, ਸੇਧ ਪ੍ਰਕਾਸ਼ਨ, ਪਟਿਆਲਾ, ੧੯੮੪',
    bibliography83: 'ਜੀ. ਐਸ. ਰਿਆਲ, ਸ਼ਬਦਾਂ ਦੀ ਪੈੜ, ਸੇਧ ਪ੍ਰਕਾਸ਼ਨ, ਪਟਿਆਲਾ, ੧੯੮੪',
    bibliography84:
      'ਜੀ. ਐਸ. ਰਿਆਲ, ਸਾਡੀ ਧਰਤੀ ਸਾਡੇ ਬੋਲ, ਪੰਜਾਬ ਸਟੇਟ ਯੂਨੀਵਰਸਿਟੀ ਟੈਕਸਟ ਬੁਕ ਬੋਰਡ, ਚੰਡੀਗੜ੍ਹ, ੧੯੮੯',
    bibliography85:
      'ਜੀ. ਐਸ. ਰਿਆਲ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਦਾ ਨਿਰੁਕਤ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੬',
    bibliography86:
      'ਜੀ. ਬੀ. ਸਿੰਘ, ਗੁਰਮੁਖੀ ਲਿਪੀ ਦਾ ਜਨਮ ਤੇ ਵਿਕਾਸ, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ਪੰਜਵੀਂ ਛਾਪ, ੨੦੧੦',
    bibliography87:
      'ਜੀ.ਬੀ ਸਿੰਘ, ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਦੀਆਂ ਪ੍ਰਾਚੀਨ ਬੀੜਾਂ, ਮਾਡਰਨ ਪਬਲੀਕੇਸ਼ਨਜ਼, ਲਾਹੌਰ, ੧੯੪੪',
    bibliography88:
      'ਜੀਤ ਸਿੰਘ ਸੀਤਲ (ਡਾ.), ਫ਼ਾਰਸੀ ਪੰਜਾਬੀ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੬',
    bibliography89:
      'ਜੋਗਾ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬੀ ਕੋਸ਼ (ਸਕੂਲ ਪੱਧਰ), ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੧੬',
    bibliography90:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਗੁਰਮੁਖੀ ਲਿਪੀ: ਸੋਮੇ ਤੇ ਵਿਕਾਸ, ਚੇਤਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਲੁਧਿਆਣਾ, ੨੦੧੭',
    bibliography91:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਗੁਰਮੁਖੀ ਲਿਪੀ: ਸੋਮੇ ਤੇ ਵਿਕਾਸ, ਚੇਤਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਲੁਧਿਆਣਾ, ੨੦੧੭',
    bibliography92:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ (ਪ੍ਰੋ.), ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਗੁਰਮੁਖੀ ਲਿਪੀ: ਸੋਮੇ ਤੇ ਵਿਕਾਸ, ਚੇਤਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਲੁਧਿਆਣਾ, ੨੦੧੭',
    bibliography93:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਸਲੋਕ ਸਹਸਕ੍ਰਿਤੀ ਤੇ ਗਾਥਾ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਤੇਰ੍ਹਵੀਂ ਛਾਪ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮',
    bibliography94:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਸਲੋਕ ਗੁਰੂ ਅੰਗਦ ਸਾਹਿਬ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਛੇਵੀਂ ਛਾਪ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੪',
    bibliography95:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਬੋਧ (ਭਾਗ-੧) ਬਾਣੀ ਬਿਉਰਾ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੦੪',
    bibliography96:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਬੋਧ (ਭਾਗ-੨) ਗੁਰਬਾਣੀ ਉਚਾਰਣ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੦੪',
    bibliography97:
      'ਜੋਗਿੰਦਰ ਸਿਘ ਤਲਵਾੜਾ (ਭਾਈ), ਗੁਰਬਾਣੀ ਦਾ ਸਰਲ ਵਿਆਕਰਣ-ਬੋਧ (ਦੋ ਭਾਗ), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੪',
    bibliography98:
      'ਜੋਗਿੰਦਰ ਸਿਘ ਤਲਵਾੜਾ (ਭਾਈ), ਗੁਰਬਾਣੀ ਦਾ ਸਰਲ ਵਿਆਕਰਣ-ਬੋਧ (ਦੋ ਭਾਗ), ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੪',
    bibliography99:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਜੈਤਸਰੀ ਕੀ ਵਾਰ ਅਤੇ ਵਾਰ ਮਾਰੂ ਡਖਣੇ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੧੦',
    bibliography100:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਨਿਤਨੇਮ ਸਰਲ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਅੱਠਵੀਂ ਛਾਪ, ੨੦੧੮',
    bibliography101:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਨਿਤਨੇਮ ਸਰਲ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਅੱਠਵੀਂ ਛਾਪ, ੨੦੧੮',
    bibliography102:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਬਾਵਨ ਅਖਰੀ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਦੂਜੀ ਛਾਪ, ੨੦੦੬',
    bibliography103:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ ਤਲਵਾੜਾ (ਭਾਈ), ਭੱਟਾਂ ਦੇ ਸਵਈਏ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੧੪',
    bibliography104:
      'ਜੋਗਿੰਦਰ ਸਿੰਘ ਪੁਆਰ, ਭਾਸ਼ਾ ਵਿਗਿਆਨ: ਸੰਕਲਪ ਅਤੇ ਦਿਸ਼ਾਵਾਂ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਅਕਾਦਮੀ, ਜਲੰਧਰ, ਪੰਜਵੀਂ ਛਾਪ, ੨੦੧੭',
    bibliography105:
      'ਜੋਧ ਸਿੰਘ (ਭਾਈ), ਸ੍ਰੀ ਕਰਤਾਰਪੁਰੀ ਬੀੜ ਦੇ ਦਰਸ਼ਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੦',
    bibliography106:
      'ਜੌਨ ਡੌਸਨ, ਹਿੰਦੂ ਮਿਥਿਹਾਸ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਚਉਥੀ ਛਾਪ, ੨੦੧੩',
    bibliography107:
      'ਤਰਲੋਚਨ ਸਿੰਘ (ਡਾ.), ਗੁਰਮੁਖੀ ਲਿਪੀ ਦਾ ਜਨਮ ਤੇ ਵਿਕਾਸ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੯',
    bibliography108:
      'ਤਰਲੋਚਨ ਸਿੰਘ (ਡਾ.), ਗੁਰਮੁਖੀ ਲਿਪੀ ਦਾ ਜਨਮ ਤੇ ਵਿਕਾਸ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੯',
    bibliography109:
      'ਤਾਰਾ ਸਿੰਘ (ਪ੍ਰੋ. ), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਰਾਗ ਰਤਨਾਵਲੀ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੧',
    bibliography110:
      'ਤਾਰਾ ਸਿੰਘ (ਪ੍ਰੋ. ), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਰਾਗ ਰਤਨਾਵਲੀ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੧',
    bibliography111:
      'ਤਾਰਾ ਸਿੰਘ (ਪ੍ਰੋ. ), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਰਾਗ ਰਤਨਾਵਲੀ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੧',
    bibliography112:
      'ਤੇਜਾ ਸਿੰਘ (ਪ੍ਰਿੰ.), ਆਸਾ ਦੀ ਵਾਰ, ਕੇਂਦਰੀ ਸਿੰਘ ਸਭਾ ਅਕੈਡਮੀ, ਚੰਡੀਗੜ, ੧੯੯੯',
    bibliography113:
      'ਤੇਜਾ ਸਿੰਘ (ਪ੍ਰਿੰ.), ਸ਼ਬਦਾਰਥ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਸ਼ਿਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮ ',
    bibliography114:
      'ਤੇਜਾ ਸਿੰਘ (ਪ੍ਰਿੰ.), ਸ਼ਬਦਾਰਥ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਸ਼ਿਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮ ',
    bibliography115:
      'ਤੇਜਾ ਸਿੰਘ (ਪ੍ਰਿੰ.), ਸ਼ਬਦਾਰਥ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਸ਼ਿਰੋਮਣੀ ਗੁਰਦੁਆਰਾ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੮ ',
    bibliography116:
      'ਦਲਜੀਤ ਸਿੰਘ ਖਹਿਰਾ (ਡਾ.), ਕੋਸ਼ਕਾਰੀ ਅਤੇ ਪੰਜਾਬੀ ਕੋਸ਼ਕਾਰੀ, ਲੋਕਗੀਤ ਪ੍ਰਕਾਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ੨੦੦੯ ',
    bibliography117:
      'ਦੁਨੀ ਚੰਦ੍ਰ, ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਦਾ ਵਿਕਾਸ, ਪੰਜਾਬ ਯੂਨੀਵਰਸਿਟੀ, ਚੰਡੀਗੜ੍ਹ, ੧੯੪੯ ',
    bibliography118:
      'ਨਰੈਣ ਸਿੰਘ (ਪੰਡਿਤ), ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਸਟੀਕ, ਵਜ਼ੀਰ ਹਿੰਦ ਪ੍ਰੈਸ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੩੬ ',
    bibliography119:
      'ਨਾਜ਼ੀਆ ਹਸਨ, ਸਿੰਧੀ ਭਾਸ਼ਾ ਦੇ ਬੁਨਿਆਦੀ ਤੱਤ, ਸਪਤਰਿਸ਼ੀ ਪਬਲੀਕੇਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ੨੦੧੭ ',
    bibliography120:
      'ਨਾਜ਼ੀਆ ਹਸਨ, ਸਿੰਧੀ ਭਾਸ਼ਾ ਦੇ ਬੁਨਿਆਦੀ ਤੱਤ, ਸਪਤਰਿਸ਼ੀ ਪਬਲੀਕੇਸ਼ਨ, ਚੰਡੀਗੜ੍ਹ, ੨੦੧੭ ',
    bibliography121:
      'ਪਰਮਜੀਤ ਸਿੰਘ ਸਿਧੂ, ਮਾਨਵ ਵਿਗਿਆਨਕ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੦ ',
    bibliography122:
      'ਪਿਆਰ ਸਿੰਘ, ਗਾਥਾ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ (ਪ੍ਰਾਚੀਨ ਹੱਥ-ਲਿਖਤ ਪੋਥੀਆਂ ਅਤੇ ਬੀੜਾਂ ਦੇ ਅਧਾਰ ‘ਤੇ), ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੯੨ ',
    bibliography123:
      'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਪ੍ਰਕਾਸ਼, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੦੪ ',
    bibliography124:
      'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਗੁਰਬਾਣੀ ਕੋਸ਼, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੬੦ ',
    bibliography125:
      'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਗੁਰੂ ਗ੍ਰੰਥ ਸੰਕੇਤ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੮੭ ',
    bibliography126:
      'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਗੁਰੂ ਗ੍ਰੰਥ ਵਿਚਾਰ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੨੦੧੧ ',
    bibliography127:
      'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਗੁਰੂ ਨਾਨਕ ਸਾਗਰ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਦੂਜੀ ਛਾਪ, ੨੦੧੯ ',
    bibliography128:
      'ਪਿਆਰਾ ਸਿੰਘ ਪਦਮ (ਪ੍ਰੋ.), ਪੰਜਾਬੀ ਬੋਲੀ ਦਾ ਇਤਿਹਾਸ, ਕਲਮ ਮੰਦਿਰ ਲੋਇਰ ਮਾਲ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੧੯੯੫ ',
    bibliography129:
      'ਪੀ. ਡੀ. ਗੁਣੇ (ਡਾ.), ਤੁਲਨਾਤਮਕ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੦੧ ',
    bibliography130:
      'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.) (ਸੰਕਲਨ ਤੇ ਸੰਪਾ.), ਅਹੀਆਪੁਰ ਵਾਲੀ ਪੋਥੀ (ਭਾਗ ਦੂਜਾ), (ਦੋ ਭਾਗ), ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੨ ',
    bibliography131:
      'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.) (ਸੰਪਾ.), ਅਹੀਆਪੁਰ ਵਾਲੀ ਪੋਥੀ (ਭਾਗ ਪਹਿਲਾ), ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੯੮ ',
    bibliography132:
      'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.) (ਸੰਪਾ.), ਪਹਿਲੀ ਪਾਤਸ਼ਾਹੀ: ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ, ਪੰਜਾਬੀ ਸਾਹਿਤ ਅਕਾਡਮੀ, ਲੁਧਿਆਣਾ, ੧੯੬੯ ',
    bibliography133:
      'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.) ਤੇ ਜੋਗਿੰਦਰ ਸਿੰਘ ਆਹਲੂਵਾਲੀਆ (ਡਾ.), ਸਿੱਖਾਂ ਦਾ ਛੋਟਾ ਮੇਲ: ਇਤਿਹਾਸ ਤੇ ਸਰਵੇਖਣ, ਪੰਜਾਬੀ ਐਜੂਕੇਸ਼ਨਲ ਐਂਡ ਕਲਚਰਲ ਫ਼ਾਊਂਡੇਸ਼ਨ, ਸੈਨ ਲਿਐਂਡਰੋ, ਕੈਲੀਫੋਰਨੀਆਂ, ੨੦੦੯ ',
    bibliography134:
      'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.), (ਸੰਪਾ.), ਸਿੱਖ ਫਲਸਫੇ ਦੀ ਰੂਪ ਰੇਖਾ, ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੧, ',
    bibliography135:
      'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.), ਪੰਜਾਬ, ਪੰਜਾਬੀ, ਪੰਜਾਬੀਅਤ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੯੮ ',
    bibliography136:
      'ਪ੍ਰੀਤਮ ਸਿੰਘ (ਪ੍ਰੋ.), ਪੰਜਾਬ, ਪੰਜਾਬੀ, ਪੰਜਾਬੀਅਤ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੧੯੯੮ ',
    bibliography137:
      'ਪ੍ਰੇਮ ਪ੍ਰਕਾਸ਼ ਸਿੰਘ (ਡਾ.), ਸਿਧਾਂਤਕ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਮਦਾਨ ਪਬਲੀਕੇਸ਼ਨਜ਼, ਪਟਿਆਲਾ, ੨੦੧੭ ',
    bibliography138:
      'ਪ੍ਰੇਮ ਪ੍ਰਕਾਸ਼ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਦਾ ਸਰੋਤ ਤੇ ਬਣਤਰ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੯੬ ',
    bibliography139:
      'ਪ੍ਰੇਮ ਪ੍ਰਕਾਸ਼ ਸਿੰਘ (ਡਾ.), ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਦਾ ਜਨਮ ਤੇ ਵਿਕਾਸ, ਮਦਾਨ ਪਬਲੀਕੇਸ਼ਨਜ਼, ਪਟਿਆਲਾ, ੨੦੧੭ ',
    bibliography140:
      'ਬਦਨ ਸਿੰਘ (ਗਿ.), ਆਦਿ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਸਟੀਕ (ਫਰੀਦਕੋਟ ਵਾਲਾ ਟੀਕਾ), (ਚਾਰ ਭਾਗ), ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੭੦ ',
    bibliography141:
      'ਬਲਕਾਰ ਸਿੰਘ, ਸਿੱਖ ਰਹੱਸਵਾਦ: ਅਨੁਭੂਤੀ ਅਤੇ ਅਭਿਵਿਅਕਤੀ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣਤਾਮਕ ਅਧਿਐਨ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੯ ',
    bibliography142:
      'ਬਲਦੇਵ ਸਿੰਘ ਚੀਮਾ (ਡਾ.), ਗੁਰਬਾਣੀ ਦਾ ਸਰਬਾਂਗੀ ਵਿਆਕਰਨ, ਚੇਤਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਲੁਧਿਆਣਾ, ੨੦੧੪ ',
    bibliography143:
      'ਬਲਦੇਵ ਸਿੰਘ ਚੀਮਾ (ਡਾ.), ਗੁਰਬਾਣੀ ਦਾ ਸਰਬਾਂਗੀ ਵਿਆਕਰਨ, ਚੇਤਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਲੁਧਿਆਣਾ, ੨੦੧੪ ',
    bibliography144:
      'ਬਲਵੰਤ ਸਿੰਘ ਢਿੱਲੋਂ (ਡਾ.), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਅਰਬੀ-ਫ਼ਾਰਸੀ ਸ਼ਬਦਾਵਲੀ ਕੋਸ਼, ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਯੂਨੀਵਰਸਿਟੀ, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੪ ',
    bibliography145:
      'ਬਲਵਿੰਦਰ ਸਿੰਘ, ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਦੇ ਕੁੰਜੀਵਤ ਸ਼ਬਦ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੦ ',
    bibliography146:
      'ਬਲਵੀਰ ਸਿੰਘ (ਡਾ.), ਨਿਰੁਕਤ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ (ਛੇ ਭਾਗ), ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੧੯੭੨ ',
    bibliography147:
      'ਬਾਬੂ ਰਾਮ ਸਕਸੈਨਾ, ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੦੧ ',
    bibliography148:
      'ਬੁਧ ਸਿੰਘ (ਸ.), ਪੋਠੋਹਾਰੀ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੨੦੦੧ ',
    bibliography149:
      'ਭਗਤ ਸਿੰਘ ਹੀਰਾ, ਗੁਰਮਤਿ ਵਿਚਾਰਧਾਰਾ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਤੀਜੀ ਛਾਪ, ੨੦੨੦ ',
    bibliography150:
      'ਮਹਿਤਾਬ ਸਿੰਘ (ਮਾਸਟਰ), ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਵਿਚ ਆਏ ਇਤਿਹਾਸਕ ਨਾਵਾਂ ਤੇ ਥਾਵਾਂ ਦਾ ਕੋਸ਼, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਸਤਵੀਂ ਛਾਪ, ੨੦੧੦ ',
    bibliography151:
      'ਮਹਿੰਦਰ ਸਿੰਘ ਰਤਨ (ਡਾ.), ਗੁਰਮਤਿ ਦਰਸ਼ਨ ਵਿਚ ੴ ਦਾ ਸੰਕਲਪ, ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਮਿਸ਼ਨ ਪਟਿਆਲਾ, ਮਿਤੀਹੀਨ ',
    bibliography152:
      'ਮਦਨ ਲਾਲ ਹਸੀਜਾ (ਡਾਇਰੈਕਟਰ), ਉਰਦੂ-ਪੰਜਾਬੀ-ਹਿੰਦੀ ਕੋਸ਼, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੯੭ ',
    bibliography153:
      'ਮਨਜੀਤ ਸਿੰਘ (ਭਾਈ), ਆਸਾ ਕੀ ਵਾਰ ਸਰਲ ਸਟੀਕ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੦੯ ',
    bibliography154:
      'ਮਨਮੰਦਰ ਸਿੰਘ, ਮਲਵਈ ਸ਼ਬਦ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੨੦੧੬ ',
    bibliography155:
      'ਮਨਮੋਹਨ ਸਹਿਗਲ (ਡਾ.), ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਇਕ ਸਭਿਆਚਾਰਕ ਸਰਵੇਖਣ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੮੭ ',
    bibliography156:
      'ਮਨੀ ਸਿੰਘ (ਗਿ.), ਸਿਧਾਂਤਕ ਸਟੀਕ, ਗੁਰਬਾਣੀ ਸਟੱਡੀਜ਼ ਸੁਸਾਇਟੀ, ਕਨੇਡਾ, ੧੯੯੩ ',
    bibliography157:
      'ਮਨੋਹਰ ਸਿੰਘ ਮਾਰਕੋ, ਹੱਥ-ਲਿਖਤ ਪ੍ਰਾਚੀਨ ਬੀੜਾਂ ਦੀ ਪਰਿਕਰਮਾ, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ੨੦੧੧ ',
    bibliography158:
      'ਮਿਹਰਬਾਨ ਜੀ ਸੋਢੀ, ਜਨਮਸਾਖੀ ਸ੍ਰੀ ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ, ਕਿਰਪਾਲ ਸਿੰਘ ਤੇ ਸਮਸ਼ੇਰ ਸਿੰਘ ਅਸ਼ੋਕ (ਸੰਪਾ.), ਖਾਲਸਾ ਕਾਲਜ, ਅੰਮ੍ਰਿਤਸਰ,੧੯੬੨ ',
    bibliography159:
      'ਮੁਹੱਮਦ ਹੁਸੈਨ ਆਜ਼ਾਦ, ਸੁਖ਼ਨ ਦਾਨਿ ਫ਼ਾਰਿਸ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੬੩ ',
    bibliography160:
      'ਮੁਹਾਉੱਦੀਨ ਕਾਦਰੀ ਜ਼ੋਰ (ਡਾ.), ਭਾਰਤੀ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੬੩ ',
    bibliography161:
      'ਮੈਕਸ ਆਰਥਰ ਮੈਕਾਲਿਫ, ਸਿਖ ਇਤਿਹਾਸ, (ਭਾਗ ਪਹਿਲਾ ਤੇ ਦੂਜਾ), ਲਾਹੌਰ ਬੁਕ ਸ਼ਾਪ, ਲੁਧਿਆਣਾ, ੨੦੧੪ ',
    bibliography162:
      'ਰਣਜੀਤ ਸਿੰਘ ਖੜਗ, ਨਾਨਕ ਸ਼ਾਇਰ ਇਵ ਕਹਿਆ, ਚੇਤਨਾ ਪ੍ਰਕਾਸ਼ਨ, ਲੁਧਿਆਣਾ, ੨੦੧੦ ',
    bibliography163:
      'ਰਣਧੀਰ ਸਿੰਘ (ਭਾਈ), ਗੁਰਬਾਣੀ ਦੀਆਂ ਲਗਾਂ ਮਾਤ੍ਰਾਂ ਦੀ ਵਿਲੱਖਣਤਾ, ਭਾਈ ਰਣਧੀਰ ਸਿੰਘ ਪਬਲਿਸ਼ਿੰਗ ਹਾਊਸ, ਲੁਧਿਆਣਾ, ਦੂਜੀ ਛਾਪ, ੧੯੮੭ ',
    bibliography164:
      'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.) (ਸੰਪਾ.), ਸਾਹਿਤ ਕੋਸ਼: ਪਰਿਭਾਸ਼ਿਕ ਸ਼ਬਦਾਵਲੀ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੧ ',

    bibliography165:
      'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਅੰਤਿਕਾ ਭਾਵ ਪ੍ਰਬੋਧਨੀ ਟੀਕਾ: ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੫ ',
    bibliography166:
      'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਅਰਥ ਬੋਧ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਆਰਸੀ ਪਬਲਿਸ਼ਰਜ਼, ਦਿੱਲੀ, ੨੦੦੭ ',
    bibliography167:
      'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਆਸਾ ਦੀ ਵਾਰ: ਵਿਸ਼ਲੇਸ਼ਣ ਅਤੇ ਵਿਆਖਿਆ, ਗੁਰਮਤਿ ਪ੍ਰਕਾਸ਼ਨ ਪਟਿਆਲਾ, ੨੦੧੭ ',
    bibliography168:
      'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਇਤਿਹਾਸ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੮ ',
    bibliography169:
      'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਗੁਰੂ ਗ੍ਰੰਥ ਵਿਸ਼ਵਕੋਸ਼ (ਭਾਗ ਪਹਿਲਾ ਤੇ ਦੂਜਾ), ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੦੨ ',
    bibliography170:
      'ਰਤਨ ਸਿੰਘ ਜੱਗੀ (ਡਾ.), ਗੁਰੂ ਨਾਨਕ: ਵਿਅਕਤਿਤ੍ਵ ਕਰਤਿਤ੍ਵ ਅਤੇ ਚਿੰਤਨ, ਭਾਸ਼ਾ ਵਿਭਾਗ, ਪੰਜਾਬ, ੧੯੭੫ ',
    bibliography171:
      'ਰਾਜਿੰਦਰ ਸਿੰਘ ਲਾਂਬਾ (ਡਾ.), ਉਰਦੂ-ਪੰਜਾਬੀ ਕੋਸ਼, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ੨੦੧੫ ',
    bibliography172:
      'ਲਾਲ ਸਿੰਘ (ਡਾਇਰੈਕਟਰ), ਪੰਜਾਬੀ ਅਤੇ ਉੱਤਰ-ਭਾਰਤੀ ਭਾਸ਼ਾਵਾਂ, ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ੧੯੭੦ ',
    bibliography173:
      'ਲਾਲ ਸਿੰਘ (ਡਾਇਰੈਕਟਰ), ਪੰਜਾਬੀ ਕੋਸ਼ (ਛੇ ਭਾਗ), ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਤੀਜੀ ਛਾਪ, ੧੯੯੦ ',
    bibliography174:
      'ਓਮ ਪ੍ਰਕਾਸ਼ ਵਸ਼ਿਸ਼ਟ, ਕੋਸ਼ ਵਿਗਿਆਨ ਅਤੇ ਪੰਜਾਬੀ ਕੋਸ਼ਕਾਰੀ, ਨੈਨਸੀ ਪਬਲਿਸ਼ਰਜ਼, ਚੰਡੀਗੜ੍ਹ, ੧੯੯੨ ',
    bibliography175:
      'ਵਜ਼ੀਰ ਸਿੰਘ, ਧਰਮ ਦਾ ਦਾਰਸ਼ਨਿਕ ਪੱਖ, ਪੰਜਾਬੀ ਯੂਨੀਵਰਸਿਟੀ, ਪਟਿਆਲਾ, ਦੂਜੀ ਛਾਪ, ੧੯੯੯ ',
    bibliography176:
      'ਵੀਰ ਸਿੰਘ (ਭਾਈ), ਸੰਥ੍ਯਾ ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ, (ਸੱਤ ਭਾਗ), ਡਾ. ਬਲਬੀਰ ਸਿੰਘ (ਸੰਪਾ.), ਭਾਸ਼ਾ ਵਿਭਾਗ ਪੰਜਾਬ, ਪਟਿਆਲਾ, ਪੰਜਵੀਂ ਛਾਪ, ੧੯੯੩ ',
    bibliography177:
      'ਵੀਰ ਸਿੰਘ (ਭਾਈ), ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਕੋਸ਼, ਸਿੰਘ ਬ੍ਰਦਰਜ਼, ਅੰਮ੍ਰਿਤਸਰ, ਸਤਵੀਂ ਛਾਪ, ੨੦੦੩ ',
    bibliography178:
      'ਵੇਦ ਅਗਨੀਹੋਤਰੀ, ਪਰਿਚਾਇਕ ਭਾਸ਼ਾ ਵਿਗਿਆਨ, ਦੀਪਕ ਪਬਲੀਸ਼ਰਜ਼, ਜਲੰਧਰ, ੧੯੯੮ ',*/
  },
};
